/* Felicitations Quote Calculator v2 - FULL path
 *
 * Phase A scope: shell + § 01/02 + tier picker visually working.
 * STD/INV/OTD/Review come in Phase B-E.
 *
 * State shape mirrors v1 + Quick so cart-add payload + ?config= URLs
 * remain interchangeable.
 */
(function() {
  'use strict';

  var state = {
    coupleNames: '',
    email: '',
    weddingDate: '',
    guestCount: '',
    categories: { std: false, inv: false, otd: false },
    selectedCategory: '',
    std: {
      on: false,
      qty: 0,
      qtyManual: false,
      printStyle: 'digital',         // 'digital' | 'luxpress' | 'acrylic'
      print: '',                     // luxpress method: 'letterpress' | 'hotfoil' | 'embossed'
      acSize: '100x150',
      ribbon: 'satin',               // 'satin' | 'velvet' | 'silk' (when checks.ribbon)
      waxType: 'adhesive',           // 'adhesive' | 'stick' (when checks.sealWax)
      checks: { sealSticker: true }
    },
    inv: {
      on: false,
      qty: 0,
      qtyManual: false,
      size: '120x180',
      format: 'flat',                // 'flat' | 'folded' | 'acrylic'
      printStyle: 'digital',
      print: '',
      infoCards: 1,                  // 0 | 1 | 2
      shapeSuite: 0,                 // 0 none | 1 invite only | 2 info1 only | 3 both info | 4 full set
      ribbon: 'satin',
      waxType: 'adhesive',
      checks: { sealSticker: true, keepsake: true }
    },
    otd: {
      on: false,
      items: {
        // Subtractive defaults: 4 essentials pre-selected (per Masha 2026-05-23)
        welcome:   { on: true,  material: 'board', size: 'A2-long', ups: {} },
        seating:   { on: true,  material: 'board', size: 'A1', ups: {} },
        bar:       { on: false, material: 'cardstock', size: 'A5', ups: {} },
        'small-c': { on: false, material: 'cardstock', size: 'A5', qty: 1, ups: {} },
        menus:     { on: true,  format: 'flat-sm', qty: 0, ribbon: 'none', ups: { compNames: true } },
        place:     { on: false, format: 'flat', qty: 0, ups: {} },
        tablenum:  { on: true,  format: 'card-sm', qty: 0, ups: {} },
        favour:    { on: false, format: 'tag100', qty: 0, ribbon: 'none', ups: {} },
        vows:      { on: false, style: 'a6-std', ribbon: 'none', ups: {} },
        guestbook: { on: false, format: 'a5', ups: {} },
        thankyou:  { on: false, format: 'postcard', qty: 0 },
        wishwell:  { on: false, format: '300' },
        // NEW items (v1 parity)
        service:   { on: false, format: 'trifold', qty: 0, ribbon: 'none', ups: {} },
        reserved:  { on: false, qty: 0 },
        decals:    { on: false },
        custom:    { on: false, note: '' }
      }
    },
    des: { type: '', checks: {} },
    requestSample: false
  };

  window.FEL_V2_FULL = window.FEL_V2_FULL || {};
  window.FEL_V2_FULL.state = state;

  function fmt0(n) {
    return '$' + Math.round(n).toLocaleString('en-AU');
  }

  // ── URL parameter hydration (state passed from Quick or share link) ────────
  function readUrlParams() {
    var p = new URLSearchParams(window.location.search);
    var guests = p.get('guests');
    var scope = p.get('scope');
    var tier = (p.get('tier') || '').toLowerCase();
    var cfg = p.get('config');

    if (cfg) {
      try {
        var decoded = JSON.parse(decodeURIComponent(escape(atob(cfg))));
        if (decoded && typeof decoded === 'object') {
          ['coupleNames', 'weddingDate', 'guestCount', 'selectedCategory'].forEach(function(k){
            if (decoded[k] != null) state[k] = decoded[k];
          });
          ['std', 'inv', 'otd', 'des'].forEach(function(k){
            if (decoded[k] && typeof decoded[k] === 'object') {
              Object.keys(decoded[k]).forEach(function(sub){
                state[k][sub] = decoded[k][sub];
              });
            }
          });
        }
      } catch (e) { console.warn('[FEL_V2_FULL] config decode failed', e); }
    }

    if (guests) state.guestCount = String(guests).replace(/[^0-9]/g, '');
    if (['full', 'inv-std', 'otd'].indexOf(scope) >= 0) state.selectedCategory = scope;
    if (['suite', 'indiv'].indexOf(tier) >= 0) state.des.type = tier;
    var startStep = parseInt(p.get('step'), 10);
    if (startStep >= 1 && startStep <= 3) state._startTab = startStep;
    // Bespoke not allowed in Full path (routes to /pages/bespoke per Masha)
  }

  // ── Hydrate UI from state on load ────────────────────────────
  function hydrateUI() {
    var byId = function(id) { return document.getElementById(id); };
    if (state.coupleNames && byId('ffNames'))     byId('ffNames').value = state.coupleNames;
    if (state.weddingDate && byId('ffDate'))      byId('ffDate').value  = state.weddingDate;
    if (state.email && byId('ffEmail'))           byId('ffEmail').value = state.email;
    if (state.guestCount && byId('ffGuests'))     byId('ffGuests').value = state.guestCount;

    if (state.selectedCategory) selectScope(state.selectedCategory);
    if (state.des.type) selectTier(state.des.type);
    refreshProofDays();
    refreshPackageSection();
    refreshTierSection();

    // Sections start collapsed on load (EDIT expands). Guarantees the default
    // even if a code path above removed the class while hydrating.
    ['custStd', 'custInv', 'custOtd'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.classList.add('collapsed');
    });

    // Apply initial reveal state for STD/INV/OTD conditional rows so defaults render correctly
    refreshStdReveal();
    refreshInvReveal();
    refreshInvEnvelopeLabel();
    refreshOtdReveal();
    // Apply format gates for items whose upgrades depend on selected format
    ['menus','tablenum'].forEach(function(id) {
      var it = state.otd.items[id];
      if (it && it.format) refreshFormatGate(id, it.format);
    });
    // Rebuild signage size dropdowns from SIGN_ALLOWED, then apply live prices
    ['welcome','seating','bar','small-c'].forEach(function(id) {
      var it = state.otd.items[id];
      if (it && it.material) refreshSignageMaterial(id, it.material);
      refreshSignagePrices(id);
    });
    // Append base prices to format/style dropdowns (menus, place, tablenum, vows, etc.)
    refreshOtdOptionPrices();
    refreshTierPrices();
    refreshDesAddonsPanel();
    // Restore previously checked addons (e.g. from ?config= hydration)
    if (state.des && state.des.checks) {
      Object.keys(state.des.checks).forEach(function(k) {
        var cb = document.querySelector('.fel-v2-full [data-deschk="' + k + '"]');
        if (cb) cb.checked = !!state.des.checks[k];
      });
    }

    recompute();
  }

  // ── Field handlers ────────────────────────────────────────────
  function onField(key, val) {
    state[key] = val;
    if (key === 'email') clearEmailError();
    recompute();
  }

  function selectScope(scope) {
    state.selectedCategory = scope;
    refreshTierPrices();
    // Block visibility: STD is also visible for inv-std (Pre-Wedding Set covers
    // both STD + Invitations). User can opt-in via toggle.
    state.categories = {
      std: scope === 'full' || scope === 'inv-std',
      inv: scope === 'full' || scope === 'inv-std',
      otd: scope === 'full' || scope === 'otd'
    };
    // Active by default: STD only for full scope; for inv-std user opts in.
    state.std.on = scope === 'full';
    state.inv.on = scope === 'full' || scope === 'inv-std';
    state.otd.on = scope === 'full' || scope === 'otd';

    // Subtractive defaults: pre-fill qty to 60% of guests when scope enables
    // STD or INV and user hasn't manually set qty yet.
    var g = parseInt(state.guestCount, 10) || 0;
    var defaultQty = g > 0 ? Math.ceil(g * 0.6) : 0;
    if (state.categories.std && !state.std.qtyManual && defaultQty > 0) {
      state.std.qty = defaultQty;
      var stdQtyEl = document.getElementById('stdQty');
      if (stdQtyEl) stdQtyEl.value = defaultQty;
    }
    if (state.categories.inv && !state.inv.qtyManual && defaultQty > 0) {
      state.inv.qty = defaultQty;
      var invQtyEl = document.getElementById('invQty');
      if (invQtyEl) invQtyEl.value = defaultQty;
    }
    // OTD subtractive defaults: menus qty = guests, table# qty = ceil(guests/10)
    if (state.categories.otd && g > 0) {
      var menus = state.otd.items.menus;
      var tnum = state.otd.items.tablenum;
      var thanks = state.otd.items.thankyou;
      if (menus && !menus.qtyManual) menus.qty = g;
      if (tnum && !tnum.qtyManual) tnum.qty = Math.max(1, Math.ceil(g / 10));
      if (thanks && !thanks.qtyManual) thanks.qty = g;
      var setVal = function(field, value) {
        var el = document.querySelector('.fel-v2-full [data-otdfield="' + field + '"]');
        if (el) el.value = value;
      };
      if (menus) setVal('menus.qty', menus.qty);
      if (tnum) setVal('tablenum.qty', tnum.qty);
      if (thanks) setVal('thankyou.qty', thanks.qty);
    }

    document.querySelectorAll('.fel-v2-full .opt[data-scope]').forEach(function(el) {
      el.classList.toggle('checked', el.getAttribute('data-scope') === scope);
    });
    updateSectionVisibility();
    refreshBlockOffState();
    refreshPackageSection();
    recompute();
  }

  function selectTier(tier) {
    state.des.type = tier;
    document.querySelectorAll('.fel-v2-full .opt[data-tier], .fel-v2-full .tier-card[data-tier]').forEach(function(el) {
      el.classList.toggle('checked', el.getAttribute('data-tier') === tier);
    });
    refreshDesAddonsPanel();
    refreshProofDays();
    refreshTierSection();
    recompute();
  }

  // First-proof timing per tier: Studio Collection 3 days, Tailored Touch 5 days.
  function proofDaysLabel() {
    if (state.des.type === 'suite') return '3 days';
    if (state.des.type === 'indiv') return '5 days';
    return '3 to 5 days';
  }
  function refreshProofDays() {
    var el = document.getElementById('proofDays');
    if (el) el.textContent = proofDaysLabel();
  }

  // Toggle a design experience add-on (illust, monogram, etc.)
  function toggleDesCheck(key, on) {
    if (!state.des.checks) state.des.checks = {};
    state.des.checks[key] = !!on;
    recompute();
  }

  // Show/hide the design add-ons panel + individual rows based on selected tier.
  // TT (indiv) → monogram is INCLUDED, so hide monogram row (only illust shown).
  // SC (suite) → illust + monogram both available as add-ons.
  // No tier or bespoke → hide entire panel.
  function refreshDesAddonsPanel() {
    var panel = document.getElementById('tierAddonsPanel');
    if (!panel) return;
    var tier = state.des && state.des.type;
    if (tier !== 'indiv' && tier !== 'suite') {
      panel.hidden = true;
      return;
    }
    panel.hidden = false;
    var monoRow = panel.querySelector('[data-desaddon="monogram"]');
    if (monoRow) {
      var monoIncluded = (tier === 'indiv');
      monoRow.hidden = false;
      monoRow.classList.toggle('addon-included', monoIncluded);
      var cb = monoRow.querySelector('input[type="checkbox"]');
      var price = document.getElementById('monogramPrice');
      if (monoIncluded) {
        // Tailored Touch: monogram comes with the tier — show it ticked, never charged
        if (state.des.checks && state.des.checks.monogram) state.des.checks.monogram = false;
        if (cb) { cb.checked = true; cb.disabled = true; }
        if (price) price.textContent = 'Included';
      } else {
        if (cb) { cb.disabled = false; cb.checked = !!(state.des.checks && state.des.checks.monogram); }
        if (price) price.textContent = '+$50';
      }
    }
  }

  // Refresh tier price labels (Studio Collection + Tailored Touch) based on
  // current scope. OTD-only and Pre-Wedding Set scopes get the reduced rates.
  function refreshTierPrices() {
    if (!window.FEL_PRICING || !window.FEL_PRICING.DESIGN) return;
    var d = window.FEL_PRICING.DESIGN;
    var reduced = (state.selectedCategory === 'otd' || state.selectedCategory === 'inv-std');
    var suitePrice = reduced ? d.suite.priceReduced : d.suite.price;
    var indivPrice = reduced ? d.indiv.priceReduced : d.indiv.price;
    var suiteEl = document.getElementById('tierPriceSuite');
    var indivEl = document.getElementById('tierPriceIndiv');
    var suiteNote = document.getElementById('tierNoteSuite');
    var indivNote = document.getElementById('tierNoteIndiv');
    if (suiteEl)  suiteEl.textContent  = '$' + Math.round(suitePrice);
    if (indivEl)  indivEl.textContent  = '$' + Math.round(indivPrice);
    if (suiteNote) suiteNote.textContent = reduced ? 'design fee · reduced rate' : 'design fee';
    if (indivNote) indivNote.textContent = reduced ? 'design fee · reduced rate' : 'design fee';
  }

  // ── Minimum quantity warnings ────────────────────────────────
  // Per v1: Luxury Presswork (letterpress / hotfoil / embossed) needs min 30,
  // Acrylic needs min 10. Below those, calc returns 0 silently - show user why.
  function refreshMinWarning(prefix, qty, ps) {
    var el = document.getElementById(prefix + 'QtyWarning');
    if (!el) return;
    var msg = '';
    if (ps === 'luxpress' && qty > 0 && qty < 30) {
      msg = 'Luxury Presswork requires a minimum quantity of 30.';
    } else if (ps === 'acrylic' && qty > 0 && qty < 10) {
      msg = 'Acrylic requires a minimum quantity of 10.';
    }
    if (msg) { el.textContent = msg; el.hidden = false; }
    else { el.hidden = true; el.textContent = ''; }
  }

  // ── STD section handlers ──────────────────────────────────────
  function onStdQty(val) {
    state.std.qty = parseInt(String(val).replace(/[^0-9]/g, ''), 10) || 0;
    state.std.qtyManual = true;
    refreshMinWarning('std', state.std.qty, state.std.printStyle);
    recompute();
  }
  function setStdPrintStyle(ps) {
    state.std.printStyle = ps;
    document.querySelectorAll('.fel-v2-full [data-stdps]').forEach(function(el) {
      el.classList.toggle('checked', el.getAttribute('data-stdps') === ps);
    });
    refreshStdReveal();
    refreshMinWarning('std', state.std.qty, ps);
    if (ps === 'luxpress' && !state.std.print) setStdPrint('letterpress');
    if (ps === 'luxpress' && state.std.print) setStdPrint(state.std.print);
    if (ps === 'acrylic' && !state.std.acSize) setStdAcSize('100x150');
    if (ps === 'acrylic' && state.std.acSize) setStdAcSize(state.std.acSize);
    recompute();
  }
  function setStdPrint(print) {
    state.std.print = print;
    document.querySelectorAll('.fel-v2-full [data-stdprint]').forEach(function(el) {
      el.classList.toggle('checked', el.getAttribute('data-stdprint') === print);
    });
    refreshStdReveal();
    recompute();
  }
  function setStdAcSize(size) {
    state.std.acSize = size;
    document.querySelectorAll('.fel-v2-full [data-stdac]').forEach(function(el) {
      el.classList.toggle('checked', el.getAttribute('data-stdac') === size);
    });
    recompute();
  }
  function toggleStdCheck(key, on) {
    if (!state.std.checks) state.std.checks = {};
    state.std.checks[key] = !!on;
    recompute();
  }
  function toggleStdRibbon(on) {
    toggleStdCheck('ribbon', on);
    var sub = document.getElementById('stdRibbonType');
    if (sub) sub.hidden = !on;
  }
  function setStdRibbon(rb) {
    state.std.ribbon = rb;
    document.querySelectorAll('.fel-v2-full [data-stdrb]').forEach(function(el) {
      el.classList.toggle('checked', el.getAttribute('data-stdrb') === rb);
    });
    recompute();
  }
  function toggleStdWax(on) {
    toggleStdCheck('sealWax', on);
    var sub = document.getElementById('stdWaxType');
    if (sub) sub.hidden = !on;
  }
  function setStdWaxType(wt) {
    state.std.waxType = wt;
    document.querySelectorAll('.fel-v2-full [data-stdwt]').forEach(function(el) {
      el.classList.toggle('checked', el.getAttribute('data-stdwt') === wt);
    });
    recompute();
  }
  // Centralised reveal logic for all STD conditional rows
  function refreshStdReveal() {
    var ps = state.std.printStyle;
    var method = state.std.print;
    function set(id, show) {
      var el = document.getElementById(id);
      if (el) el.hidden = !show;
    }
    set('stdDigitalUps', ps === 'digital');
    set('stdPressMethod', ps === 'luxpress');
    set('stdLpAddons', ps === 'luxpress' && method === 'letterpress');
    set('stdHfAddons', ps === 'luxpress' && method === 'hotfoil');
    set('stdEmAddons', ps === 'luxpress' && method === 'embossed');
    set('stdAcSize', ps === 'acrylic');
    set('stdAcAddons', ps === 'acrylic');
    // Hide Custom Cut row for acrylic (not applicable)
    var cutRow = document.getElementById('stdCutRow');
    if (cutRow) cutRow.hidden = ps === 'acrylic';
  }

  // ── INV section handlers ──────────────────────────────────────
  function invMinWarningKey() {
    // INV: when format=flat use printStyle directly; when format=acrylic use 'acrylic'
    if (state.inv.format === 'acrylic') return 'acrylic';
    if (state.inv.format === 'flat') return state.inv.printStyle;
    return '';
  }
  function onInvQty(val) {
    state.inv.qty = parseInt(String(val).replace(/[^0-9]/g, ''), 10) || 0;
    state.inv.qtyManual = true;
    refreshMinWarning('inv', state.inv.qty, invMinWarningKey());
    recompute();
  }
  function setInvSize(size) {
    state.inv.size = size;
    document.querySelectorAll('.fel-v2-full [data-invsize]').forEach(function(el) {
      el.classList.toggle('checked', el.getAttribute('data-invsize') === size);
    });
    refreshInvEnvelopeLabel();
    recompute();
  }
  function setInvFormat(fmt) {
    state.inv.format = fmt;
    document.querySelectorAll('.fel-v2-full [data-invformat]').forEach(function(el) {
      el.classList.toggle('checked', el.getAttribute('data-invformat') === fmt);
    });
    refreshInvReveal();
    refreshMinWarning('inv', state.inv.qty, invMinWarningKey());
    recompute();
  }
  function setInvPrintStyle(ps) {
    state.inv.printStyle = ps;
    document.querySelectorAll('.fel-v2-full [data-invps]').forEach(function(el) {
      el.classList.toggle('checked', el.getAttribute('data-invps') === ps);
    });
    refreshInvReveal();
    refreshMinWarning('inv', state.inv.qty, invMinWarningKey());
    if (ps === 'luxpress' && !state.inv.print) setInvPrint('letterpress');
    if (ps === 'luxpress' && state.inv.print) setInvPrint(state.inv.print);
    recompute();
  }
  function setInvPrint(print) {
    state.inv.print = print;
    document.querySelectorAll('.fel-v2-full [data-invprint]').forEach(function(el) {
      el.classList.toggle('checked', el.getAttribute('data-invprint') === print);
    });
    refreshInvReveal();
    recompute();
  }
  function setInvInfo(n) {
    state.inv.infoCards = parseInt(n, 10) || 0;
    document.querySelectorAll('.fel-v2-full [data-invinfo]').forEach(function(el) {
      el.classList.toggle('checked', parseInt(el.getAttribute('data-invinfo'), 10) === state.inv.infoCards);
    });
    // Shape Suite "Both info cards" option only valid when infoCards === 2
    var bothBtn = document.querySelector('.fel-v2-full [data-invshape="3"]');
    if (bothBtn) bothBtn.hidden = state.inv.infoCards !== 2;
    // Reset shape suite if current value is no longer valid
    if (state.inv.shapeSuite === 3 && state.inv.infoCards !== 2) setInvShape(0);
    if (state.inv.shapeSuite > 0 && state.inv.infoCards === 0 && state.inv.shapeSuite !== 1) setInvShape(0);
    recompute();
  }
  function setInvShape(n) {
    state.inv.shapeSuite = parseInt(n, 10) || 0;
    document.querySelectorAll('.fel-v2-full [data-invshape]').forEach(function(el) {
      el.classList.toggle('checked', parseInt(el.getAttribute('data-invshape'), 10) === state.inv.shapeSuite);
    });
    recompute();
  }
  function toggleInvCheck(key, on) {
    if (!state.inv.checks) state.inv.checks = {};
    state.inv.checks[key] = !!on;
    recompute();
  }
  function toggleInvRibbon(on) {
    toggleInvCheck('ribbon', on);
    var sub = document.getElementById('invRibbonType');
    if (sub) sub.hidden = !on;
  }
  function setInvRibbon(rb) {
    state.inv.ribbon = rb;
    document.querySelectorAll('.fel-v2-full [data-invrb]').forEach(function(el) {
      el.classList.toggle('checked', el.getAttribute('data-invrb') === rb);
    });
    recompute();
  }
  function toggleInvWax(on) {
    toggleInvCheck('sealWax', on);
    var sub = document.getElementById('invWaxType');
    if (sub) sub.hidden = !on;
  }
  function setInvWaxType(wt) {
    state.inv.waxType = wt;
    document.querySelectorAll('.fel-v2-full [data-invwt]').forEach(function(el) {
      el.classList.toggle('checked', el.getAttribute('data-invwt') === wt);
    });
    recompute();
  }
  // INV envelope upgrade label depends on size (per v1 calcINV)
  function refreshInvEnvelopeLabel() {
    var size = state.inv.size;
    var envKey = size === '148x210' ? 'C5' : size === '120x180' ? '130×190' : 'C6';
    var price = size === '148x210' ? 1.90 : size === '120x180' ? 1.40 : 0.90;
    var lbl = document.getElementById('invEnvLabel');
    var prc = document.getElementById('invEnvPrice');
    if (lbl) lbl.textContent = '(' + envKey + ')';
    if (prc) prc.textContent = '+$' + price.toFixed(2) + '/ea';
  }
  // Centralised reveal logic for all INV conditional rows
  function refreshInvReveal() {
    var fmt = state.inv.format;
    var ps = state.inv.printStyle;
    var method = state.inv.print;
    function set(id, show) {
      var el = document.getElementById(id);
      if (el) el.hidden = !show;
    }
    // Print style row only relevant for flat
    set('invPrintStyleRow', fmt === 'flat');
    // Digital upgrades only for flat + digital
    set('invDigitalUps', fmt === 'flat' && ps === 'digital');
    // Luxpress method + addons only for flat + luxpress
    set('invPressMethod', fmt === 'flat' && ps === 'luxpress');
    set('invLpAddons', fmt === 'flat' && ps === 'luxpress' && method === 'letterpress');
    set('invHfAddons', fmt === 'flat' && ps === 'luxpress' && method === 'hotfoil');
    set('invEmAddons', fmt === 'flat' && ps === 'luxpress' && method === 'embossed');
    // Folded foil addons only for folded format
    set('invFoldedAddons', fmt === 'folded');
    // Acrylic addons only for acrylic format
    set('invAcrylicAddons', fmt === 'acrylic');
  }

  // ── OTD item handlers ────────────────────────────────────────
  // Map item id to its config wrapper id (camelCase-ish)
  var OTD_CFG_IDS = {
    welcome: 'otdCfgWelcome',
    seating: 'otdCfgSeating',
    bar: 'otdCfgBar',
    'small-c': 'otdCfgSmallC',
    menus: 'otdCfgMenus',
    place: 'otdCfgPlace',
    tablenum: 'otdCfgTablenum',
    favour: 'otdCfgFavour',
    decals: 'otdCfgDecals',
    vows: 'otdCfgVows',
    guestbook: 'otdCfgGuestbook',
    thankyou: 'otdCfgThankyou',
    wishwell: 'otdCfgWishwell',
    service: 'otdCfgService',
    reserved: 'otdCfgReserved',
    custom: 'otdCfgCustom'
  };

  function toggleOtdItem(id, on) {
    if (!state.otd.items[id]) return;
    state.otd.items[id].on = !!on;
    var cfg = document.getElementById(OTD_CFG_IDS[id]);
    if (cfg) cfg.hidden = !on;
    recompute();
  }

  function setOtdField(id, field, value) {
    if (!state.otd.items[id]) return;
    if (field === 'qty') {
      var n = parseInt(String(value).replace(/[^0-9]/g, ''), 10) || 0;
      state.otd.items[id].qty = n;
      state.otd.items[id].qtyManual = true;
    } else {
      state.otd.items[id][field] = value;
    }
    // For signage items, when material changes, reveal correct upgrade subset + size options
    if (field === 'material' && ['welcome','seating','bar','small-c'].indexOf(id) >= 0) {
      refreshSignageMaterial(id, value);
      refreshSignagePrices(id);
    }
    // For signage size changes, recompute live upgrade prices
    if (field === 'size' && ['welcome','seating','bar','small-c'].indexOf(id) >= 0) {
      refreshSignagePrices(id);
    }
    // For items where format determines which upgrades apply (menus, tablenum, etc.)
    if (field === 'format') {
      refreshFormatGate(id, value);
    }
    recompute();
  }

  // Hide upgrades whose data-fmtgate rule doesn't allow the current format.
  // Rules: not-fabric, cardstock, acrylic, rigid (cardstock + acrylic).
  // When an upgrade is hidden, its checkbox is unchecked and the state flag cleared,
  // so totals don't include "ghost" upgrades from a previous format choice.
  function refreshFormatGate(id, format) {
    var cfgId = OTD_CFG_IDS[id];
    var cfg = cfgId ? document.getElementById(cfgId) : null;
    if (!cfg) return;
    var fmt = String(format || '');
    var isFabric  = fmt.indexOf('fab') === 0 || fmt.indexOf('fabric') === 0;
    var isCardSt  = fmt.indexOf('card') === 0;
    var isAcrylic = fmt.indexOf('acrylic') === 0;
    var item = state.otd.items[id];
    cfg.querySelectorAll('.cb-inline[data-fmtgate]').forEach(function(el) {
      var rule = el.getAttribute('data-fmtgate');
      var allowed = true;
      if (rule === 'not-fabric')      allowed = !isFabric;
      else if (rule === 'cardstock')  allowed = isCardSt;
      else if (rule === 'acrylic')    allowed = isAcrylic;
      else if (rule === 'rigid')      allowed = isCardSt || isAcrylic;
      el.hidden = !allowed;
      if (!allowed) {
        var cb = el.querySelector('input[type="checkbox"]');
        if (cb && cb.checked) {
          cb.checked = false;
          var upKey = (cb.getAttribute('data-otdup') || '').split('.')[1];
          if (item && item.ups && upKey) item.ups[upKey] = false;
        }
      }
    });
  }

  // Look up live signage upgrade prices (cut / stand / foil) for current
  // material + size and write them into each .upgrade-price span. If the
  // combo has no price (null in OTD_SIGNAGE), hide the whole row + uncheck.
  function refreshSignagePrices(id) {
    if (!window.FEL_PRICING || !window.FEL_PRICING.OTD_SIGNAGE) return;
    var cfgId = OTD_CFG_IDS[id];
    var cfg = cfgId ? document.getElementById(cfgId) : null;
    if (!cfg) return;
    var it = state.otd.items[id];
    if (!it) return;
    var sig = window.FEL_PRICING.OTD_SIGNAGE;
    // Map fabric-linen and fabric-linen-narrow to 'fabric' table key
    var matKey = (it.material === 'fabric-linen' || it.material === 'fabric-linen-narrow')
      ? 'fabric'
      : it.material;
    var sizeKey = it.size;
    var sizeData = (sig[matKey] && sig[matKey][sizeKey]) || null;
    var isFabric = (matKey === 'fabric');

    cfg.querySelectorAll('.cb-inline[data-priceup]').forEach(function(el) {
      var key = el.getAttribute('data-priceup');
      var priceEl = el.querySelector('.upgrade-price');
      if (!priceEl) return;

      var amount = null;
      if (isFabric) {
        // Fabric sign upgrades use flat OTD_SIGNAGE.fabricUp constants
        var fabMap = { cut: null, stand: null, foil: null, eyelets: sig.fabricUp.eyelets,
                       hemming: sig.fabricUp.linenHemming, loopHem: sig.fabricUp.loopHem,
                       ribbon: sig.fabricUp.ribbon5cmBow };
        amount = fabMap[key];
      } else {
        // Rigid (board/acrylic/cardstock): cut/stand/foil come from sizeData
        if (sizeData && (key === 'cut' || key === 'stand' || key === 'foil')) {
          amount = sizeData[key];
        } else if (key === 'dispHoles')   amount = sig.rigidUp.dispHoles;
        else if (key === 'hangRibbon')    amount = sig.rigidUp.hangRibbon;
      }

      if (amount == null || amount === 0) {
        // Not available for this material/size combo - hide + clear state
        el.classList.add('priceup-na');
        var cb = el.querySelector('input[type="checkbox"]');
        if (cb && cb.checked) {
          cb.checked = false;
          if (it.ups && it.ups[key]) it.ups[key] = false;
        }
        priceEl.textContent = '–';
      } else {
        el.classList.remove('priceup-na');
        priceEl.textContent = '+$' + Math.round(amount);
      }
    });
  }

  // ── Live STD upgrade prices (qty + print style + acSize dependent) ──
  // For each STD upgrade label with data-priceup="std.<key>", look up the
  // tier-band or size-dependent price and write it into the price span.
  function fmtPrice(n) {
    if (n == null) return '–';
    var s = (Math.round(n * 100) / 100).toString();
    if (s.indexOf('.') >= 0) s = s.replace(/0+$/, '').replace(/\.$/, '');
    return '$' + s;
  }
  function refreshStdPrices() {
    var P = window.FEL_PRICING; if (!P) return;
    var s = state.std;
    var q = parseInt(s.qty, 10) || 0;
    var t = P.tierDigital(Math.max(q, 1));
    var tp = P.tierPress(Math.max(q, 1));
    var ta = P.tierAcrylic(Math.max(q, 1));
    var ps = s.printStyle;
    var print = s.print;

    document.querySelectorAll('.fel-v2-full [data-priceup^="std."]').forEach(function(el) {
      var key = el.getAttribute('data-priceup').split('.')[1];
      var priceEl = el.querySelector('.upgrade-price, .cb-price');
      if (!priceEl) return;
      var amount = null;
      var suffix = '/ea';
      if (key === 'foilS') {
        amount = (ps === 'digital' && t >= 0) ? P.STD.digital.addons.foilSingle[t] : null;
      } else if (key === 'duplex') {
        amount = (ps === 'digital' && t >= 0) ? P.STD.digital.addons.duplexing[t] : null;
      } else if (key === 'acMirror') {
        amount = (ps === 'acrylic' && P.STD.acrylic.mirror[s.acSize] != null)
          ? P.STD.acrylic.mirror[s.acSize] : null;
      } else if (key === 'cut') {
        // Custom cut depends on current print style + tier
        if (ps === 'digital' && t >= 0)              amount = P.STD.digital.addons.cutToShape[t];
        else if (ps === 'luxpress' && tp >= 0 && print && P.STD[print] && P.STD[print].addons.cutToShape)
                                                      amount = P.STD[print].addons.cutToShape[tp];
        else if (ps === 'acrylic')                   amount = null; // not applicable for acrylic
      }
      if (amount == null) {
        priceEl.textContent = '–';
        el.classList.add('priceup-na');
      } else {
        priceEl.textContent = '+' + fmtPrice(amount) + suffix;
        el.classList.remove('priceup-na');
      }
    });
  }

  // ── Live INV upgrade prices ──
  function refreshInvPrices() {
    var P = window.FEL_PRICING; if (!P) return;
    var s = state.inv;
    var q = parseInt(s.qty, 10) || 0;
    var effQ = q > 0 ? q : (parseInt(state.guestCount, 10) || 60);
    var t = P.tierDigital(Math.max(effQ, 1));
    var tp = P.tierPress(Math.max(effQ, 1));
    var ta = P.tierAcrylic(Math.max(effQ, 1));
    var tA = P.tierOTD(Math.max(effQ, 1));
    var size = s.size || '120x180';

    document.querySelectorAll('.fel-v2-full [data-priceup^="inv."]').forEach(function(el) {
      var key = el.getAttribute('data-priceup').split('.')[1];
      var priceEl = el.querySelector('.upgrade-price, .cb-price');
      if (!priceEl) return;
      var amount = null;
      var label = '+';
      var suffix = '/ea';
      if (key === 'dsp') {
        amount = (s.format === 'flat' && s.printStyle === 'digital' && t >= 0)
          ? P.INV.digital.addons.doubleSided[t] : null;
      } else if (key === 'foilS') {
        amount = (s.format === 'flat' && s.printStyle === 'digital' && P.INV.digital.addons.foilSingle[size] != null)
          ? P.INV.digital.addons.foilSingle[size] : null;
      } else if (key === 'duplex') {
        amount = (s.format === 'flat' && s.printStyle === 'digital' && t >= 0)
          ? P.INV.digital.addons.duplexing[t] : null;
      } else if (key === 'acMirror') {
        amount = (s.format === 'acrylic') ? P.INV.acrylic.mirror : null;
      } else if (key === 'band' && ta >= 0) {
        amount = P.INV.accessories.band[tA];
      } else if (key === 'vellum') {
        amount = P.INV.accessories.vellum[tA];
      } else if (key === 'pockets') {
        amount = P.INV.accessories.laserPocketSimple[tA];
      } else if (key === 'envUp') {
        var envKey = size === '148x210' ? 'C5' : size === '120x180' ? '130x190' : 'C6';
        amount = P.ENVELOPES.upgrade[envKey];
      } else if (key === 'assembly') {
        amount = P.INV.assembly[tA];
        suffix = ' one-off';
      }
      if (amount == null) {
        priceEl.textContent = '–';
        el.classList.add('priceup-na');
      } else {
        priceEl.textContent = label + fmtPrice(amount) + suffix;
        el.classList.remove('priceup-na');
      }
    });
  }

  // Show/hide upgrade checkboxes + size options based on material category
  function refreshSignageMaterial(id, material) {
    var isFabric = material && material.indexOf('fabric') >= 0;
    var cfgId = OTD_CFG_IDS[id];
    var cfg = document.getElementById(cfgId);
    if (!cfg) return;
    // Toggle upgrade checkboxes by data-mat
    cfg.querySelectorAll('.cb-inline[data-mat]').forEach(function(el) {
      var mat = el.getAttribute('data-mat');
      el.hidden = (isFabric && mat === 'rigid') || (!isFabric && mat === 'fabric');
    });
    // Rebuild size dropdown from SIGN_ALLOWED - hidden attr on <option> is
    // unreliable across browsers, so we rewrite the list entirely.
    var sizeEl = cfg.querySelector('[data-otdfield="' + id + '.size"]');
    if (!sizeEl || !window.FEL_PRICING) return;
    var allowed = (window.FEL_PRICING.SIGN_ALLOWED[id] && window.FEL_PRICING.SIGN_ALLOWED[id][material]) || [];
    var labels = window.FEL_PRICING.SIZE_LABELS || {};
    var PICKUP_ONLY = { 'A0':1, '800x1500':1, '900x1800':1, '1100x2100':1 };
    var sig = window.FEL_PRICING.OTD_SIGNAGE;
    var matKey = (material === 'fabric-linen' || material === 'fabric-linen-narrow') ? 'fabric' : material;
    var prevValue = state.otd.items[id].size;
    sizeEl.innerHTML = '';
    allowed.forEach(function(sz) {
      var opt = document.createElement('option');
      opt.value = sz;
      var lbl = labels[sz] || sz;
      // Append base price per option so couples see the cost of each size choice
      var entry = sig[matKey] && sig[matKey][sz];
      var basePrice = null;
      if (entry) {
        if (typeof entry.base === 'number')      basePrice = entry.base;
        else if (typeof entry.linen === 'number') basePrice = entry.linen; // fabric uses {linen, satin}
      }
      if (basePrice != null) lbl += ' · $' + Math.round(basePrice);
      if (PICKUP_ONLY[sz]) lbl += ' · Perth pick-up only';
      opt.textContent = lbl;
      opt.setAttribute('data-mat', isFabric ? 'fabric' : 'rigid');
      sizeEl.appendChild(opt);
    });
    // Preserve prior selection if still valid, else pick first
    if (allowed.indexOf(prevValue) >= 0) {
      sizeEl.value = prevValue;
    } else if (allowed.length) {
      sizeEl.value = allowed[0];
      state.otd.items[id].size = allowed[0];
    }
  }

  // Append base prices to OTD format/style/size dropdown options.
  // Runs once at hydration; format option prices don't change with qty (we show
  // "from $X/ea" for tier-banded items so the starting price stays accurate).
  function refreshOtdOptionPrices() {
    var P = window.FEL_PRICING; if (!P) return;
    var cheapest = function(arr) { if (!arr || !arr.length) return null; return arr[arr.length - 1]; };
    var apply = function(selector, lookup) {
      var sel = document.querySelector('.fel-v2-full [data-otdfield="' + selector + '"]');
      if (!sel) return;
      Array.from(sel.options).forEach(function(opt) {
        if (/\$/.test(opt.textContent)) return; // already has price
        var price = lookup(opt.value);
        if (price && price.amt != null) {
          opt.textContent = opt.textContent + ' · ' + price.label + '$' + price.amt;
        }
      });
    };
    apply('menus.format', function(v) {
      var arr = P.OTD_MENUS.base[v]; if (!arr) return null;
      return { label: 'from ', amt: cheapest(arr) };
    });
    apply('place.format', function(v) {
      var arr = P.OTD_PLACECARDS.base[v]; if (!arr) return null;
      return { label: 'from ', amt: cheapest(arr) };
    });
    apply('tablenum.format', function(v) {
      var e = P.OTD_TABLENUMBERS[v]; if (!e || typeof e.base !== 'number') return null;
      return { label: '', amt: e.base };
    });
    apply('vows.style', function(v) {
      var e = P.OTD_VOWBOOKS[v]; if (!e) return null;
      return { label: '', amt: e.base };
    });
    apply('guestbook.format', function(v) {
      var e = P.OTD_GUESTBOOK[v]; if (!e) return null;
      return { label: '', amt: e.base };
    });
    apply('thankyou.format', function(v) {
      var amt = P.OTD_THANKYOU[v]; if (amt == null) return null;
      return { label: '', amt: amt };
    });
    apply('wishwell.format', function(v) {
      var amt = P.OTD_WISHINGWELL[v]; if (amt == null) return null;
      return { label: '', amt: amt };
    });
    apply('favour.format', function(v) {
      var arr = P.OTD_FAVOURS.base[v]; if (!arr) return null;
      return { label: 'from ', amt: cheapest(arr) };
    });
    apply('service.format', function(v) {
      var arr = (P.OTD_BOOKLETS.base[v] || P.OTD_PROGRAMS.base[v]);
      if (!arr) return null;
      return { label: 'from ', amt: cheapest(arr) };
    });
  }

  // Toggle an upgrade flag inside item.ups (e.g. cut, stand, foil, dsp, ribbon)
  function toggleOtdUpgrade(id, field, on) {
    if (!state.otd.items[id]) return;
    if (!state.otd.items[id].ups) state.otd.items[id].ups = {};
    state.otd.items[id].ups[field] = !!on;
    recompute();
  }

  // Set ribbon type on an OTD item (none/satin/velvet/silk)
  function setOtdRibbon(id, type) {
    if (!state.otd.items[id]) return;
    state.otd.items[id].ribbon = type;
    document.querySelectorAll('.fel-v2-full [data-otdrb^="' + id + '."]').forEach(function(el) {
      el.classList.toggle('checked', el.getAttribute('data-otdrb') === id + '.' + type);
    });
    recompute();
  }

  // INV pockets: toggle the master checkbox + reveal/hide foil sub-picker
  function toggleInvPockets(on) {
    toggleInvCheck('pockets', on);
    var sub = document.getElementById('invPocketFoil');
    if (sub) sub.hidden = !on;
    if (!on) state.inv.pocketSFoil = 'none';
  }
  function setInvPocketFoil(v) {
    state.inv.pocketSFoil = v;
    document.querySelectorAll('.fel-v2-full [data-invpf]').forEach(function(el) {
      el.classList.toggle('checked', el.getAttribute('data-invpf') === v);
    });
    recompute();
  }

  // Sync .off class on each section block with state.{std,inv,otd}.on
  function refreshBlockOffState() {
    var pairs = [
      ['custStd', state.std.on],
      ['custInv', state.inv.on],
      ['custOtd', state.otd.on]
    ];
    pairs.forEach(function(pair) {
      var el = document.getElementById(pair[0]);
      if (el) el.classList.toggle('off', !pair[1]);
    });
  }

  // Refresh OTD item visibility (config strips) based on item.on state
  function refreshOtdReveal() {
    Object.keys(OTD_CFG_IDS).forEach(function(id) {
      var item = state.otd.items[id];
      if (!item) return;
      var cfg = document.getElementById(OTD_CFG_IDS[id]);
      var head = document.querySelector('.fel-v2-full [data-otditem="' + id + '"]');
      if (cfg) cfg.hidden = !item.on;
      if (head) head.checked = !!item.on;
      // Reflect saved field values into selects/inputs
      Object.keys(item).forEach(function(field) {
        if (field === 'on' || field === 'ups' || field === 'qtyManual' || field === 'ribbon') return;
        var el = document.querySelector('.fel-v2-full [data-otdfield="' + id + '.' + field + '"]');
        if (el) el.value = item[field];
      });
    });
  }

  // ── Show/hide STD/INV/OTD placeholder cards by scope ─────────
  function updateSectionVisibility() {
    var stdEl = document.getElementById('custStd');
    var invEl = document.getElementById('custInv');
    var otdEl = document.getElementById('custOtd');
    if (stdEl) stdEl.hidden = !state.categories.std;
    if (invEl) invEl.hidden = !state.categories.inv;
    if (otdEl) otdEl.hidden = !state.categories.otd;
  }

  // ── Live recompute using FEL_PRICING detailed calculators ────
  function recompute() {
    var sbAmt = document.getElementById('sbAmt');
    var stdSub = document.getElementById('stdSubtotal');
    var invSub = document.getElementById('invSubtotal');
    var otdSub = document.getElementById('otdSubtotal');

    if (!window.FEL_PRICING) return;

    var hasScope = !!state.selectedCategory;
    var hasTier = !!state.des.type;
    if (!hasScope || !hasTier) {
      if (sbAmt) sbAmt.innerHTML = '<span>$0</span>';
      if (stdSub) stdSub.textContent = '$0';
      if (invSub) invSub.textContent = '$0';
      if (otdSub) otdSub.textContent = '$0';
      var emptyMsg = '<p class="review-empty">Pick a stationery collection and design experience to see your itemised investment.</p>';
      var emptyWrap = document.getElementById('reviewPhases');
      if (emptyWrap) emptyWrap.innerHTML = emptyMsg;
      var estSumEmpty = document.getElementById('estSum');
      if (estSumEmpty) estSumEmpty.innerHTML = emptyMsg;
      var dtBtn = document.getElementById('estDetailToggle');
      if (dtBtn) dtBtn.hidden = true;
      return;
    }

    var breakdown = window.FEL_PRICING.calcAll(state);
    if (stdSub) stdSub.textContent = breakdown.std > 0 ? fmt(breakdown.std) : '–';
    if (invSub) invSub.textContent = breakdown.inv > 0 ? fmt(breakdown.inv) : '–';
    if (otdSub) otdSub.textContent = breakdown.otd > 0 ? fmt(breakdown.otd) : '–';
    if (sbAmt) sbAmt.innerHTML = '<span>' + fmt0(breakdown.total) + '</span>';
    renderEstSummary(breakdown);
    renderReviewPhases(breakdown);
    renderBlockSummaries();
    refreshStdPrices();
    refreshInvPrices();
    refreshFeeBlock(breakdown);
  }

  function fmt(n) {
    return '$' + (Math.round(n * 100) / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // ── Itemised breakdown for Tab 3 ────────────────────────────
  var SIZE_LBL = {
    '100x150': '100×150mm', '120x180': '120×180mm', '148x210': 'A5 (148×210)',
    '70x70': '70×70mm', 'A6':'A6', 'A5':'A5', 'A4':'A4', 'A3':'A3', 'A2':'A2',
    'A2-long':'A2 Long', 'A1':'A1', 'A1-long':'A1 Long', 'A0':'A0',
    '800x1500':'800×1500', '900x1800':'900×1800', '1100x2100':'1100×2100',
    '60-70cm_1m':'Up to 1m', '60-70cm_2m':'Up to 2m', '60-70cm_2.4m':'Up to 2.4m',
    '30-40cm_1m':'Up to 1m (30–40cm)', '30-40cm_1.5m':'Up to 1.5m', '30-40cm_1.8m':'Up to 1.8m'
  };
  var PRINT_LBL = { digital:'Digital', luxpress:'Luxury Presswork', acrylic:'Acrylic', letterpress:'Letterpress', hotfoil:'Hot foil', embossed:'Embossed' };
  var MATERIAL_LBL = { board:'Board', acrylic:'Acrylic', cardstock:'Cardstock', 'fabric-linen':'Fabric (linen)', 'fabric-linen-narrow':'Fabric (linen)' };
  var FORMAT_LBL = {
    // Menus
    'flat-sm':'Flat 100×200', 'flat-lg':'Flat 120×200 / A5', 'round':'Round', 'folded':'Folded',
    'folded-a5':'Folded A5', 'fabric-sm':'Fabric 120×200', 'fabric-lg':'Fabric 130×300', 'triangle':'Triangle',
    // Place cards
    'flat':'The Petite Flat', 'cutshape':'Sculptural Flat', 'coaster':'Coaster Acrylic', 'glass':'Glass place card',
    'tag100':'Tag 100×50', 'tag50':'Tag 50×50',
    // Table numbers
    'card-sm':'Cardstock 100×150', 'card-classic':'Cardstock 100×200', 'card-md':'Cardstock 148×210',
    'fab-std':'Fabric 30×1m', 'fab-grand':'Fabric 30×1.5m',
    'acrylic-sm':'The Minimalist Acrylic', 'acrylic-md':'The Editorial Acrylic',
    // Vows
    'a6-std':'A6 Standard', 'a5-std':'A5 Standard', 'a6-hm':'A6 Handmade', 'a5-hm':'A5 Handmade',
    // Thank you
    'postcard':'Postcard', 'with-env':'With envelope',
    // Guest book
    'a5':'A5 acrylic', 'a4':'A4 acrylic',
    // Wishing well
    '300':'300×300mm', '600':'300×600mm',
    // Service
    'trifold':'Trifold program', 'booklet':'Stapled booklet', 'leaflet':'Single-page leaflet'
  };
  var ITEM_LBL = {
    welcome:'Welcome sign', seating:'Seating chart', bar:'Bar sign', 'small-c':'Small signage',
    menus:'Menus', place:'Place cards', tablenum:'Table numbers', favour:'Favour tags',
    vows:'Vow books', guestbook:'Guest book', thankyou:'Thank you cards', wishwell:'Wishing well',
    service:'Order of service', reserved:'Reserved seating cards', decals:'Custom decals',
    custom:'Something else'
  };
  function lblSize(s) { return SIZE_LBL[s] || s || ''; }
  function lblMat(m) { return MATERIAL_LBL[m] || m || ''; }
  function lblFmt(f) { return FORMAT_LBL[f] || f || ''; }
  function lblPrint(p) { return PRINT_LBL[p] || p || ''; }

  function ribbonName(r) { return r === 'satin' ? 'Satin ribbon' : r === 'velvet' ? 'Velvet ribbon' : r === 'silk' ? 'Silk ribbon' : ''; }
  function waxName(t) { return t === 'stick' ? 'Stick wax' : 'Adhesive wax'; }

  function stdSummary() {
    var s = state.std;
    if (!s || !s.on) return { included: false };
    var lines = [];
    var qty = parseInt(s.qty, 10) || 0;
    var head = qty + ' card' + (qty === 1 ? '' : 's');
    if (s.printStyle === 'acrylic') {
      head += ' · ' + lblPrint('acrylic') + ' ' + lblSize(s.acSize);
    } else if (s.printStyle === 'luxpress') {
      head += ' · ' + lblPrint('luxpress') + (s.print ? ' (' + lblPrint(s.print) + ')' : '');
    } else {
      head += ' · ' + lblPrint('digital') + ' ' + lblSize('100x150');
    }
    lines.push(head);
    var c = s.checks || {};
    var addons = [];
    if (c.foilS) addons.push('Foil single');
    if (c.duplex) addons.push('Duplexing');
    if (c.cut) addons.push('Cut to shape');
    if (c.acMirror) addons.push('Mirror acrylic upgrade');
    if (c.lp2pms) addons.push('Second PMS colour');
    if (c.lpFoil || c.emHf) addons.push('Hot foil add');
    if (c.hfDigital) addons.push('Digital base under foil');
    if (c.hfLp || c.emLp) addons.push('Letterpress add');
    if (addons.length) lines.push(addons.join(' · '));
    var env = [];
    if (c.envUp) env.push('Envelopes upgraded');
    if (c.envAddr) env.push('Printed addressing');
    if (c.envLiner) env.push('Liners');
    if (c.envEmb) env.push('Embossed envelope stamp');
    if (env.length) lines.push(env.join(' · '));
    var seal = [];
    if (c.sealSticker) seal.push('Custom sticker seal');
    if (c.sealWax) seal.push('Wax seal · ' + waxName(s.waxType));
    if (c.sealEmb) seal.push('Embossed seal');
    if (seal.length) lines.push(seal.join(' · '));
    if (c.ribbon && s.ribbon && s.ribbon !== 'none') lines.push(ribbonName(s.ribbon));
    if (c.magnet) lines.push('Magnets (complimentary)');
    return { included: true, lines: lines };
  }

  function invSummary() {
    var s = state.inv;
    if (!s || !s.on) return { included: false };
    var lines = [];
    var qty = parseInt(s.qty, 10) || 0;
    var head = (qty > 0 ? qty + ' invitation' + (qty === 1 ? '' : 's') : 'Assembly only');
    if (s.format === 'acrylic') head += ' · Acrylic ' + lblSize(s.size);
    else if (s.format === 'folded') head += ' · Folded ' + lblSize(s.size);
    else head += ' · ' + lblPrint(s.printStyle || 'digital') + (s.print ? ' (' + lblPrint(s.print) + ')' : '') + ' · ' + lblSize(s.size);
    lines.push(head);
    if (s.infoCards >= 1) lines.push('+ ' + s.infoCards + ' info card' + (s.infoCards > 1 ? 's' : ''));
    var shapeTxt = ['', 'Cut to shape · invite only', 'Cut to shape · info card 1', 'Cut to shape · invite + info cards', 'Cut to shape · full set'];
    if (s.shapeSuite && shapeTxt[s.shapeSuite]) lines.push(shapeTxt[s.shapeSuite]);
    var c = s.checks || {};
    var addons = [];
    if (c.dsp) addons.push('Double-sided print');
    if (c.foilS) addons.push('Foil single');
    if (c.duplex) addons.push('Duplexing');
    if (c.foldFoilS) addons.push('Folded foil single');
    if (c.foldFoilD) addons.push('Folded foil double');
    if (c.acMirror) addons.push('Mirror acrylic upgrade');
    if (c.acNames) addons.push('Per-guest acrylic names');
    if (c.lp2pms) addons.push('Second PMS colour');
    if (c.lpFoil || c.emHf) addons.push('Hot foil add');
    if (c.hfDigital) addons.push('Digital base under foil');
    if (c.hfLp || c.emLp) addons.push('Letterpress add');
    if (addons.length) lines.push(addons.join(' · '));
    var acc = [];
    if (c.vellum) acc.push('Vellum wrap' + (c.vellumFoil ? ' + foil' : ''));
    if (c.band) acc.push('Vellum band' + (c.bandFoil ? ' + foil' : ''));
    if (c.pockets) acc.push('Laser-cut pockets');
    if (c.clips) acc.push('Paper clips');
    if (acc.length) lines.push(acc.join(' · '));
    var env = [];
    if (c.envUp) env.push('Envelopes upgraded');
    if (c.envAddr) env.push('Printed addressing');
    if (c.envLiner) env.push('Liners');
    if (c.envEmb) env.push('Embossed envelope stamp');
    if (env.length) lines.push(env.join(' · '));
    var seal = [];
    if (c.sealSticker) seal.push('Custom sticker seal');
    if (c.sealWax) seal.push('Wax seal · ' + waxName(s.waxType));
    if (c.sealEmb) seal.push('Embossed seal');
    if (seal.length) lines.push(seal.join(' · '));
    if (c.ribbon && s.ribbon && s.ribbon !== 'none') lines.push(ribbonName(s.ribbon));
    if (c.assembly) lines.push('Hand-assembly');
    return { included: true, lines: lines };
  }

  function otdSummary() {
    var s = state.otd;
    if (!s || !s.on) return { included: false };
    var lines = [];
    var items = s.items || {};
    var order = ['welcome','seating','bar','small-c','place','menus','tablenum','vows','guestbook','thankyou','wishwell','service','reserved','favour','decals','custom'];
    order.forEach(function(id) {
      var it = items[id];
      if (!it || !it.on) return;
      var label = ITEM_LBL[id] || id;
      var bits = [];
      if (it.material) bits.push(lblMat(it.material));
      if (it.size && !it.material) bits.push(lblSize(it.size));
      else if (it.size) bits.push(lblSize(it.size));
      if (it.format) bits.push(lblFmt(it.format));
      if (it.style) bits.push(lblFmt(it.style));
      var q = parseInt(it.qty, 10) || 0;
      if (q > 0) bits.push(q + (id === 'menus' || id === 'place' || id === 'favour' || id === 'thankyou' || id === 'tablenum' || id === 'reserved' || id === 'small-c' ? ' pcs' : ''));
      var line = label + (bits.length ? ' · ' + bits.join(' · ') : '');
      var ups = it.ups || {};
      var upList = [];
      if (ups.cut) upList.push('cut to shape');
      if (ups.stand) upList.push('stand');
      if (ups.foil) upList.push('foil');
      if (ups.dispHoles) upList.push('display holes');
      if (ups.hangRibbon) upList.push('hanging ribbon');
      if (ups.eyelets) upList.push('eyelets');
      if (ups.hemming) upList.push('linen hemming');
      if (ups.loopHem) upList.push('loop hem');
      if (ups.ribbon) upList.push('5cm ribbon bow');
      if (ups.dsp) upList.push('double-sided');
      if (ups.mirror) upList.push('mirror acrylic');
      if (ups.layers) upList.push('layered numbers');
      if (it.ribbon && it.ribbon !== 'none') upList.push(ribbonName(it.ribbon).toLowerCase());
      if (upList.length) line += ' (' + upList.join(', ') + ')';
      if (id === 'custom' && it.note) line += ' · ' + it.note;
      if (id === 'decals' || id === 'custom') line += ' · TBQ';
      lines.push(line);
    });
    if (!lines.length) return { included: false };
    return { included: true, lines: lines };
  }

  function desSummary() {
    if (!state.des || !state.des.type) return { included: false };
    var tierLabel = TIER_LABELS[state.des.type] || state.des.type;
    var reduced = (state.selectedCategory === 'otd' || state.selectedCategory === 'inv-std');
    var lines = [tierLabel + (reduced ? ' · ' + (SCOPE_LABELS[state.selectedCategory] || '') + ' rate' : '')];
    var c = state.des.checks || {};
    var addons = [];
    if (c.illust) addons.push('Custom illustration / map');
    if (c.monogram) addons.push('Custom monogram');
    if (c.extraRev) addons.push('Extra revision round');
    if (c.printReady) addons.push('Extended print-ready files');
    if (c.samplePrints) addons.push('Sample prints');
    if (addons.length) lines.push(addons.join(' · '));
    return { included: true, lines: lines };
  }

  // ── Investment summary: print per phase, production balance, then the Design Fee ──
  function renderEstSummary(breakdown) {
    var wrap = document.getElementById('estSum');
    if (!wrap) return;
    var rows = [];
    var row = function(l, v, cls) {
      return '<div class="est-sum-row' + (cls ? ' ' + cls : '') + '"><span class="est-sum-l">' + l + '</span><span class="est-sum-v">' + v + '</span></div>';
    };
    if (state.categories.std && state.std.on && breakdown.std > 0) rows.push(row('Save the Dates · print', fmt(breakdown.std)));
    if (state.categories.inv && state.inv.on && breakdown.inv > 0) rows.push(row('Invitations · print', fmt(breakdown.inv)));
    if (state.categories.otd && state.otd.on && breakdown.otd > 0) rows.push(row('On-the-day · print', fmt(breakdown.otd)));
    var print = breakdown.std + breakdown.inv + breakdown.otd;
    rows.push(row('Estimated Production Balance', fmt(print), 'est-sum-prod'));
    var tierLabel = TIER_LABELS[state.des.type] || '';
    var scopeLabel = SCOPE_LABELS[state.selectedCategory] || '';
    rows.push(row('Design Fee · ' + escHtml(tierLabel) + (scopeLabel ? ' · ' + escHtml(scopeLabel) : ''), fmt(breakdown.des), 'est-sum-fee'));
    rows.push('<hr class="est-sum-hr">');
    rows.push(row('Estimated total', fmt(breakdown.total) + ' <span class="est-sum-cur">AUD</span>', 'est-sum-grand'));
    rows.push(row('Design Fee due today', fmt(breakdown.des) + ' <span class="est-sum-cur">AUD</span>', 'est-sum-due'));
    rows.push(row('Remaining Production Balance', fmt(print) + ' <span class="est-sum-cur">AUD</span>', 'est-sum-remain'));
    rows.push('<p class="est-sum-note">Invoiced in phases, as you approve each piece for print. Save the dates first, invitations next, on-the-day closer to your date.</p>');
    wrap.innerHTML = rows.join('');
    var dtBtn = document.getElementById('estDetailToggle');
    if (dtBtn) dtBtn.hidden = false;
  }

  // "Review itemised selection detail" accordion on the estimate step
  function toggleEstDetail() {
    var panel = document.getElementById('reviewPhases');
    var btn = document.getElementById('estDetailToggle');
    if (!panel) return;
    panel.hidden = !panel.hidden;
    if (btn) {
      btn.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
      btn.classList.toggle('open', !panel.hidden);
    }
  }

  // One-line description of what each package covers (shown under the note)
  var SCOPE_DESCS = {
    'full': 'One design across your save the dates, invitations and every on-the-day piece.',
    'inv-std': 'Your invitation suite, with save the dates included.',
    'otd': 'Signage, menus, place cards and every piece your guests see on the day.'
  };
  var TIER_DESCS = {
    'suite': 'Our designed suites, ready to make yours. First proof in 3 days, two revision rounds.',
    'indiv': 'Three concepts, designed with you. First proof in 5 days, four revision rounds.'
  };

  // "Change" opens the package question inline (accordion), right below the note
  function changePackage(e) {
    if (e) e.preventDefault();
    var section = document.getElementById('packageSection');
    if (!section) return;
    section.hidden = !section.hidden;
    if (!section.hidden) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Hide the duplicate package question when the customer already chose on the scoper
  function refreshPackageSection() {
    var section = document.getElementById('packageSection');
    var note = document.getElementById('pkgNote');
    var noteLabel = document.getElementById('pkgNoteLabel');
    var noteDesc = document.getElementById('pkgNoteDesc');
    var hasScope = !!state.selectedCategory;
    if (section) section.hidden = hasScope;
    if (note) note.hidden = !hasScope;
    if (noteLabel && hasScope) noteLabel.textContent = SCOPE_LABELS[state.selectedCategory] || '';
    if (noteDesc) noteDesc.textContent = hasScope ? (SCOPE_DESCS[state.selectedCategory] || '') : '';
  }

  // "Change" reopens the tier cards inline
  function changeTier(e) {
    if (e) e.preventDefault();
    var chooser = document.getElementById('tierChooser');
    if (!chooser) return;
    chooser.hidden = !chooser.hidden;
    if (!chooser.hidden) chooser.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Collapse the tier cards to a note line once a design experience is chosen
  function refreshTierSection() {
    var chooser = document.getElementById('tierChooser');
    var note = document.getElementById('tierNote');
    var noteName = document.getElementById('tierNoteName');
    var noteDesc = document.getElementById('tierNoteDesc');
    var hasTier = state.des.type === 'suite' || state.des.type === 'indiv';
    if (chooser) chooser.hidden = hasTier;
    if (note) note.hidden = !hasTier;
    if (noteName && hasTier) noteName.textContent = TIER_LABELS[state.des.type] || '';
    if (noteDesc) noteDesc.textContent = hasTier ? (TIER_DESCS[state.des.type] || '') : '';
  }

  function renderReviewPhases(breakdown) {
    var wrap = document.getElementById('reviewPhases');
    if (!wrap) return;
    var hasScope = !!state.selectedCategory;
    var hasTier = !!(state.des && state.des.type);
    if (!hasScope || !hasTier) {
      wrap.innerHTML = '<p class="review-empty">Pick a stationery collection and design experience to see your itemised investment.</p>';
      return;
    }

    var phases = [
      { key:'std', title:'Save the Dates',    sum: stdSummary(), amt: breakdown.std, visible: state.categories.std },
      { key:'inv', title:'Invitations',       sum: invSummary(), amt: breakdown.inv, visible: state.categories.inv },
      { key:'otd', title:'On-the-day',        sum: otdSummary(), amt: breakdown.otd, visible: state.categories.otd },
      { key:'des', title:'Design experience', sum: desSummary(), amt: breakdown.des }
    ];

    var html = phases.map(function(p) {
      if (p.visible === false) return '';
      var off = !p.sum.included;
      var sub = off ? 'Not included' : (p.amt > 0 ? fmt0(p.amt) : 'Configured');
      var body = off
        ? ''
        : '<ul class="phase-lines">' + (p.sum.lines || []).map(function(l){ return '<li>' + escHtml(l) + '</li>'; }).join('') + '</ul>';
      var editLabel = 'Edit ' + p.title.toLowerCase();
      var editIcon = '<button type="button" class="phase-edit-icon-btn" onclick="FEL_V2_FULL.editPhase(\'' + p.key + '\')" aria-label="' + escHtml(editLabel) + '" title="' + escHtml(editLabel) + '">✎</button>';
      return '<div class="review-phase' + (off ? ' off' : '') + '">' +
               '<div class="phase-head">' +
                 '<span class="phase-name">' + escHtml(p.title) + '</span>' +
                 '<span class="phase-right">' +
                   '<span class="phase-sub">' + escHtml(sub) + '</span>' +
                   editIcon +
                 '</span>' +
               '</div>' + body +
             '</div>';
    }).join('');

    wrap.innerHTML = html || '<p class="review-empty">Nothing configured yet. Head back to Tab 2.</p>';
  }

  // Jump back to Tab 2 and expand the relevant section for editing
  function editPhase(key) {
    goTab(2);
    setTimeout(function() {
      if (key === 'des') {
        var tierEl = document.querySelector('.fel-v2-full .tier-block');
        if (tierEl) tierEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      var blockId = 'cust' + key.charAt(0).toUpperCase() + key.slice(1);
      var block = document.getElementById(blockId);
      if (!block) return;
      // Ensure block is on + expanded so the user can edit immediately
      if (state[key] && !state[key].on) {
        state[key].on = true;
        block.classList.remove('off');
      }
      block.classList.remove('collapsed');
      block.scrollIntoView({ behavior: 'smooth', block: 'start' });
      recompute();
    }, 200);
  }

  // ── Tab 3 Design Fee block + Sample Kit + secure CTA label ──────
  function refreshFeeBlock(breakdown) {
    var feeEl = document.getElementById('feeAmt');
    var ctaEl = document.getElementById('secureCtaLabel');
    var amt = breakdown && breakdown.des ? breakdown.des : 0;
    if (feeEl) feeEl.textContent = amt > 0 ? fmt0(amt) : '$0';
    if (ctaEl) {
      ctaEl.textContent = amt > 0
        ? 'Secure my spot · ' + fmt0(amt) + ' Design Fee →'
        : 'Secure my spot →';
    }
  }

  function toggleSampleKit(on) {
    state.requestSample = !!on;
    recompute();
  }

  // ── Per-block one-line summary shown when section is collapsed ───
  function renderBlockSummaries() {
    var map = [
      { id: 'stdSummaryLine', sum: stdSummary, on: state.std.on },
      { id: 'invSummaryLine', sum: invSummary, on: state.inv.on },
      { id: 'otdSummaryLine', sum: otdSummary, on: state.otd.on }
    ];
    map.forEach(function(m) {
      var el = document.getElementById(m.id);
      if (!el) return;
      if (!m.on) {
        el.hidden = true;
        return;
      }
      var s = m.sum();
      if (!s.included || !s.lines.length) {
        el.textContent = 'Not configured yet';
        el.hidden = false;
        return;
      }
      // Take first line as the highlight; if multiple lines exist, append " + N more"
      var head = s.lines[0];
      var rest = s.lines.length - 1;
      el.textContent = head + (rest > 0 ? '  · +' + rest + ' more refinement' + (rest === 1 ? '' : 's') : '');
      el.hidden = false;
    });
  }

  function escHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  // ── Actions ───────────────────────────────────────────────────
  var SCOPE_LABELS = {
    'full': 'Everything',
    'inv-std': 'Invitations',
    'otd': 'On-the-day'
  };
  var TIER_LABELS = {
    'suite': 'Studio Collection',
    'indiv': 'Tailored Touch',
    'bespoke': 'Bespoke Design'
  };

  function isValidEmail(e) {
    if (!e || typeof e !== 'string') return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.trim());
  }

  function clearEmailError() {
    var el = document.getElementById('ffEmail');
    if (el) el.classList.remove('input-error');
  }

  function showCtaToast(msg) {
    var existing = document.getElementById('felV2FullToast');
    if (existing) existing.remove();
    var el = document.createElement('div');
    el.id = 'felV2FullToast';
    el.textContent = msg;
    el.style.cssText = 'position:fixed;left:50%;bottom:96px;transform:translateX(-50%);background:#2a2520;color:#faf9f7;padding:12px 18px;border-radius:8px;font:14px DM Sans,system-ui,sans-serif;z-index:9999;box-shadow:0 6px 24px rgba(0,0,0,0.18);max-width:90vw;text-align:center';
    document.body.appendChild(el);
    setTimeout(function(){ if (el && el.parentNode) el.parentNode.removeChild(el); }, 4200);
  }

  function getVariantId() {
    var FEL = window.FELICITATIONS;
    var scope = state.selectedCategory;
    var tier = state.des && state.des.type;
    if (!FEL || !FEL.variantMap || !scope || !tier) return null;
    var byScope = FEL.variantMap[scope];
    return (byScope && byScope[tier]) || null;
  }

  function showLoader(text) {
    var overlay = document.getElementById('__felV2FullLoader');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = '__felV2FullLoader';
      overlay.innerHTML = '<div class="__fcl-spin"></div><div class="__fcl-text">' + (text || 'Securing your design…') + '</div>';
      var style = document.createElement('style');
      style.textContent = [
        '#__felV2FullLoader{position:fixed;inset:0;z-index:999999;background:rgba(250,249,247,0.97);display:flex;align-items:center;justify-content:center;flex-direction:column;gap:22px;font-family:DM Sans,sans-serif;animation:__fcl-in 0.18s ease-out}',
        '#__felV2FullLoader .__fcl-spin{width:44px;height:44px;border:3px solid #e4ddd5;border-top-color:#7a2535;border-radius:50%;animation:__fcl-rot 0.8s linear infinite}',
        '#__felV2FullLoader .__fcl-text{font-family:Fraunces,Georgia,serif;font-size:1.1rem;color:#2a2520;font-weight:300;letter-spacing:0.01em}',
        '@keyframes __fcl-rot{to{transform:rotate(360deg)}}',
        '@keyframes __fcl-in{from{opacity:0}to{opacity:1}}'
      ].join('');
      document.head.appendChild(style);
      document.body.appendChild(overlay);
    }
    overlay.style.display = 'flex';
  }
  function hideLoader() {
    var overlay = document.getElementById('__felV2FullLoader');
    if (overlay) overlay.style.display = 'none';
  }

  function buildSnapshotForCart() {
    var breakdown = (window.FEL_PRICING && typeof window.FEL_PRICING.calcAll === 'function')
      ? window.FEL_PRICING.calcAll(state)
      : { std: 0, inv: 0, otd: 0, des: 0, total: 0 };
    if (!state.quoteId) {
      state.quoteId = 'FEL-' + Math.random().toString(36).slice(2, 10).toUpperCase();
    }
    return {
      quoteId: state.quoteId,
      totals: breakdown,
      coupleNames: state.coupleNames || '',
      email: state.email || '',
      weddingDate: state.weddingDate || '',
      guestCount: state.guestCount || '',
      selectedCategory: state.selectedCategory || '',
      tier: (state.des && state.des.type) || ''
    };
  }

  function onSecureCta() {
    var btns = document.querySelectorAll('.btn-secure-spot, .sticky-bar .btn-primary');
    var variantId = getVariantId();

    if (!state.selectedCategory) {
      showCtaToast('Pick a stationery collection first (Tab 1, § 02).');
      goTab(1);
      return;
    }
    if (!state.des || !state.des.type) {
      showCtaToast('Choose a design experience first (Tab 2).');
      goTab(2);
      return;
    }
    if (!isValidEmail(state.email)) {
      showCtaToast('Add your email so we can hold your spot and send confirmation.');
      goTab(1);
      setTimeout(function(){
        var el = document.getElementById('ffEmail');
        if (el) { el.focus(); el.classList.add('input-error'); }
      }, 350);
      return;
    }
    if (!variantId) {
      showCtaToast('Design Fee checkout unavailable for this combination. Email info@felicitations.com.au.');
      return;
    }

    var snap = buildSnapshotForCart();

    btns.forEach(function(b){ b.disabled = true; b.dataset.label = b.textContent; b.textContent = 'Redirecting…'; });
    showLoader();

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'calc_v2_full_secured',
        scope: snap.selectedCategory,
        tier: snap.tier,
        deposit: snap.totals.des,
        full_estimate: snap.totals.total
      });
    } catch (e) {}

    // "Edit your selection" in the cart: reopens the builder on the Customise step
    // with this exact configuration restored (otd-cart-tidy.js renders the link).
    var editUrl = window.location.pathname + '?mode=full&config=' + encodeStateForUrl() + '&step=2';
    var productLabel = ({
      'full': 'Full wedding suite',
      'inv-std': 'Invitations (Save the Dates included)',
      'otd': 'On-the-day stationery'
    })[snap.selectedCategory] || 'Wedding stationery';
    var printTotal = Number(snap.totals.std || 0) + Number(snap.totals.inv || 0) + Number(snap.totals.otd || 0);

    var properties = {
      'Product': productLabel + ' (' + (TIER_LABELS[snap.tier] || snap.tier) + ')',
      '_edit_url': editUrl,
      'Wedding Date': snap.weddingDate || 'TBD',
      'Guest Count': snap.guestCount || 'TBD',
      'Couple Names': snap.coupleNames || '',
      'Contact Email': snap.email || '',
      'Scope': SCOPE_LABELS[snap.selectedCategory] || snap.selectedCategory,
      'Design': TIER_LABELS[snap.tier] || snap.tier,
      'Design Fee (AUD)': '$' + Number(snap.totals.des || 0).toFixed(2),
      'Save the Dates · print (AUD)': snap.totals.std > 0 ? '$' + Number(snap.totals.std).toFixed(2) : '',
      'Invitations · print (AUD)': snap.totals.inv > 0 ? '$' + Number(snap.totals.inv).toFixed(2) : '',
      'On-the-day · print (AUD)': snap.totals.otd > 0 ? '$' + Number(snap.totals.otd).toFixed(2) : '',
      'Estimated Production Balance (AUD)': '$' + printTotal.toFixed(2),
      'Full Estimate (AUD)': '$' + Number(snap.totals.total || 0).toFixed(2),
      'Quote ID': snap.quoteId,
      '_source': 'calc-v2-full'
    };
    Object.keys(properties).forEach(function(k) { if (!properties[k]) delete properties[k]; });

    // Per-section selection detail so the merchant sees exactly what's inside
    // each subtotal (e.g. what makes up the STD $350), not just the total.
    function _secLines(sum) {
      return (sum && sum.included && sum.lines && sum.lines.length) ? sum.lines.join(' | ') : '';
    }
    var _stdSel = _secLines(stdSummary());
    var _invSel = _secLines(invSummary());
    var _otdSel = _secLines(otdSummary());
    var _desSel = _secLines(desSummary());
    if (_stdSel) properties['Save the Dates - Selections'] = _stdSel;
    if (_invSel) properties['Invitations - Selections']    = _invSel;
    if (_otdSel) properties['On-the-day - Selections']      = _otdSel;
    if (_desSel) properties['Design - Selections']          = _desSel;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: 1, properties: properties })
    }).then(function(res) {
      if (!res || !res.ok) {
        return res.text().then(function(body){
          throw new Error('cart/add.js ' + (res && res.status) + ': ' + (body || '').slice(0, 200));
        });
      }
      window.location.href = '/checkout';
    }).catch(function(err) {
      console.error('[FEL_V2_FULL] cart-add failed', err);
      hideLoader();
      btns.forEach(function(b){ b.disabled = false; b.textContent = b.dataset.label || 'Secure your spot'; });
      showCtaToast('Cart error: ' + (err.message || 'unknown') + '. Email info@felicitations.com.au.');
    });
  }
  function openBookCall(e) {
    if (e) e.preventDefault();
    window.open('https://felicitations.com.au/pages/wedding-stationery-consultation', '_blank', 'noopener');
  }

  function onStickyContinue() {
    var cur = parseInt(state.currentTab, 10) || 1;
    if (cur < 3) { goTab(cur + 1); return; }
    onSecureCta();
  }

  // ── Share with partner ───────────────────────────────────────
  function encodeStateForUrl() {
    try {
      var raw = JSON.stringify({
        coupleNames: state.coupleNames || '',
        weddingDate: state.weddingDate || '',
        guestCount: state.guestCount || '',
        selectedCategory: state.selectedCategory || '',
        std: state.std,
        inv: state.inv,
        otd: state.otd,
        des: state.des
      });
      return btoa(unescape(encodeURIComponent(raw)));
    } catch (e) { return ''; }
  }

  function buildShareUrl() {
    var enc = encodeStateForUrl();
    var base = location.origin + location.pathname + '?mode=full';
    return enc ? (base + '&config=' + enc) : base;
  }

  function shareWithPartner() {
    var url = buildShareUrl();
    var done = function() { showCtaToast('Link copied. Paste anywhere to pick up where you left off.'); };
    if (navigator.share) {
      navigator.share({
        title: 'Our wedding stationery estimate',
        text: 'Take a look at our quote',
        url: url
      }).catch(function(){
        copyToClipboard(url, done);
      });
      return;
    }
    copyToClipboard(url, done);
  }

  function copyToClipboard(text, cb) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(cb, function(){ fallbackCopy(text, cb); });
    } else {
      fallbackCopy(text, cb);
    }
  }
  function fallbackCopy(text, cb) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;top:-1000px;left:-1000px;opacity:0';
    document.body.appendChild(ta);
    ta.focus(); ta.select();
    try { document.execCommand('copy'); cb && cb(); } catch (e) {}
    document.body.removeChild(ta);
  }

  // ── Download as PDF (dedicated A4 layout in new window) ──────
  function downloadEstimate() {
    var breakdown = (window.FEL_PRICING && typeof window.FEL_PRICING.calcAll === 'function')
      ? window.FEL_PRICING.calcAll(state)
      : { std: 0, inv: 0, otd: 0, des: 0, total: 0 };
    if (!state.quoteId) state.quoteId = 'FEL-' + Math.random().toString(36).slice(2, 10).toUpperCase();
    var html = buildPdfHtml(breakdown);
    var w = window.open('', '_blank', 'width=920,height=1180');
    if (!w) {
      showCtaToast('Allow pop-ups to view your quote, or use Share with Partner instead.');
      return;
    }
    w.document.open();
    w.document.write(html);
    w.document.close();
    w.focus();
  }

  function buildPdfHtml(breakdown) {
    var scopeLbl = SCOPE_LABELS[state.selectedCategory] || '–';
    var tierLbl  = TIER_LABELS[state.des && state.des.type] || '–';
    var couple   = state.coupleNames || '';
    var date     = state.weddingDate || '';
    var guests   = state.guestCount || '';
    var quoteId  = state.quoteId;
    var totalAmt = breakdown.total || 0;
    var feeAmt   = breakdown.des || 0;
    var today    = new Date().toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' });

    // Build phase blocks via existing summary helpers
    var phases = [
      { key:'std', title:'Save the Dates',    sum: stdSummary(), amt: breakdown.std, visible: state.categories.std },
      { key:'inv', title:'Invitations',       sum: invSummary(), amt: breakdown.inv, visible: state.categories.inv },
      { key:'otd', title:'On-the-day',        sum: otdSummary(), amt: breakdown.otd, visible: state.categories.otd },
      { key:'des', title:'Design experience', sum: desSummary(), amt: breakdown.des }
    ];
    var phasesHtml = phases.map(function(p) {
      if (p.visible === false) return '';
      var off = !p.sum.included;
      if (off) return '<div class="pdf-phase pdf-phase-off"><div class="pdf-phase-head"><span class="pdf-phase-name">' + escHtml(p.title) + '</span><span class="pdf-phase-amt">Not included</span></div></div>';
      var amt = p.amt > 0 ? fmt0(p.amt) : '–';
      var lines = (p.sum.lines || []).map(function(l){ return '<li>' + escHtml(l) + '</li>'; }).join('');
      return '<div class="pdf-phase">' +
               '<div class="pdf-phase-head"><span class="pdf-phase-name">' + escHtml(p.title) + '</span><span class="pdf-phase-amt">' + escHtml(amt) + '</span></div>' +
               (lines ? '<ul class="pdf-phase-lines">' + lines + '</ul>' : '') +
             '</div>';
    }).join('');

    var dateLbl = date ? new Date(date).toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' }) : '';
    var metaBits = [];
    if (couple) metaBits.push(escHtml(couple));
    if (dateLbl) metaBits.push(escHtml(dateLbl));
    if (guests) metaBits.push(escHtml(guests) + ' guests');
    var metaLine = metaBits.length ? metaBits.join(' · ') : 'Your wedding stationery quote';

    var css = [
      '@page { size: A4; margin: 16mm 14mm; }',
      '* { box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; }',
      'html, body { margin: 0; padding: 0; }',
      'body { font-family: "DM Sans", -apple-system, BlinkMacSystemFont, sans-serif; color: #2a2520; background: #ebe7e0; line-height: 1.55; font-size: 11pt; }',
      // Top toolbar (screen only - hidden in print)
      '.pdf-toolbar { position: sticky; top: 0; z-index: 10; background: #2a2520; color: #faf9f7; padding: 14px 24px; display: flex; align-items: center; justify-content: space-between; gap: 18px; box-shadow: 0 2px 12px rgba(0,0,0,0.18); }',
      '.pdf-toolbar-left { display: flex; flex-direction: column; gap: 2px; }',
      '.pdf-toolbar-title { font-family: "Fraunces", Georgia, serif; font-style: italic; font-size: 1rem; margin: 0; }',
      '.pdf-toolbar-meta { font-size: 0.72rem; letter-spacing: 0.14em; text-transform: uppercase; color: rgba(255,255,255,0.6); margin: 0; }',
      '.pdf-toolbar-actions { display: flex; gap: 10px; }',
      '.pdf-toolbar-btn { font-family: "DM Sans", sans-serif; font-size: 0.78rem; letter-spacing: 0.14em; text-transform: uppercase; padding: 10px 18px; border-radius: 4px; cursor: pointer; border: 1px solid transparent; transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease; }',
      '.pdf-toolbar-btn-primary { background: #E8D9B4; color: #2a2520; border-color: #E8D9B4; font-weight: 500; }',
      '.pdf-toolbar-btn-primary:hover { background: #f0e3c0; }',
      '.pdf-toolbar-btn-ghost { background: transparent; color: #faf9f7; border-color: rgba(255,255,255,0.3); }',
      '.pdf-toolbar-btn-ghost:hover { border-color: #E8D9B4; color: #E8D9B4; }',
      // A4 paper sheet centred on grey background
      '.pdf-sheet-wrap { padding: 32px 16px 64px; display: flex; justify-content: center; }',
      '.pdf-sheet { width: 210mm; min-height: 297mm; background: #ffffff; padding: 16mm 14mm; box-shadow: 0 6px 32px rgba(42,37,32,0.18); }',
      '.pdf-doc { max-width: 182mm; margin: 0 auto; padding: 0; }',
      // Header
      '.pdf-head { text-align: center; padding-bottom: 14mm; border-bottom: 1px solid #e4ddd5; margin-bottom: 10mm; }',
      '.pdf-brand { font-size: 8pt; letter-spacing: 0.22em; text-transform: uppercase; color: #7a7570; margin: 0 0 6mm; font-weight: 500; }',
      '.pdf-title { font-family: "Fraunces", Georgia, serif; font-weight: 200; font-style: italic; font-size: 28pt; color: #2a2520; margin: 0 0 4mm; letter-spacing: -0.01em; line-height: 1.05; }',
      '.pdf-title em { color: #7a2535; font-style: italic; }',
      '.pdf-meta { font-family: "Fraunces", Georgia, serif; font-style: italic; font-size: 11pt; color: #5a5550; margin: 0; }',
      '.pdf-quote-id { display: inline-block; margin-top: 3mm; font-family: "DM Sans", sans-serif; font-style: normal; font-size: 8pt; letter-spacing: 0.16em; text-transform: uppercase; color: #7a7570; }',
      // Package summary line
      '.pdf-package { text-align: center; background: #FDF7EC; border-radius: 3px; padding: 5mm 8mm; margin-bottom: 8mm; font-family: "Fraunces", Georgia, serif; font-style: italic; font-size: 11pt; color: #3d3830; }',
      '.pdf-package strong { font-style: normal; color: #7a1c1a; font-weight: 500; }',
      '.pdf-package-desc { font-family: "DM Sans", sans-serif; font-style: normal; font-size: 9.5pt; color: #5a5550; margin: 3mm 0 0; line-height: 1.6; }',
      // Section heading
      '.pdf-section-head { font-family: "DM Sans", sans-serif; font-size: 8pt; letter-spacing: 0.22em; text-transform: uppercase; color: #7a2535; font-weight: 500; margin: 0 0 4mm; padding-bottom: 2mm; border-bottom: 1px solid #e4ddd5; }',
      // Phases
      '.pdf-phases { margin-bottom: 10mm; }',
      '.pdf-phase { padding: 4mm 0; border-bottom: 1px dotted #e4ddd5; page-break-inside: avoid; }',
      '.pdf-phase:last-child { border-bottom: none; }',
      '.pdf-phase-off { opacity: 0.55; }',
      '.pdf-phase-head { display: flex; justify-content: space-between; align-items: baseline; gap: 6mm; margin-bottom: 2mm; }',
      '.pdf-phase-name { font-family: "Fraunces", Georgia, serif; font-style: italic; font-size: 13pt; color: #2a2520; }',
      '.pdf-phase-amt { font-family: "Fraunces", Georgia, serif; font-weight: 300; font-size: 13pt; color: #7a2535; letter-spacing: -0.01em; }',
      '.pdf-phase-off .pdf-phase-amt { font-style: italic; color: #7a7570; font-size: 10pt; }',
      '.pdf-phase-lines { list-style: none; padding: 0; margin: 0; }',
      '.pdf-phase-lines li { font-size: 10pt; color: #3d3830; padding: 1mm 0 1mm 5mm; position: relative; line-height: 1.5; }',
      '.pdf-phase-lines li::before { content: "·"; position: absolute; left: 0; color: #7a2535; font-weight: 700; }',
      // Total bar
      '.pdf-total-bar { background: #2a2520; color: #faf9f7; padding: 7mm 9mm; border-radius: 3px; display: flex; justify-content: space-between; align-items: center; margin-bottom: 6mm; page-break-inside: avoid; }',
      '.pdf-total-label { font-size: 8pt; letter-spacing: 0.22em; text-transform: uppercase; color: rgba(255,255,255,0.7); font-weight: 500; }',
      '.pdf-total-amt { font-family: "Fraunces", Georgia, serif; font-weight: 200; font-size: 20pt; color: #E8D9B4; letter-spacing: -0.02em; }',
      // Design Fee
      '.pdf-fee { background: #FDF7EC; border: 1px solid rgba(122,37,53,0.18); border-radius: 4px; padding: 7mm 9mm; text-align: center; margin-bottom: 10mm; page-break-inside: avoid; }',
      '.pdf-fee-eyebrow { font-family: "DM Sans", sans-serif; font-size: 8pt; letter-spacing: 0.24em; text-transform: uppercase; color: #7a2535; margin: 0 0 2mm; font-weight: 500; }',
      '.pdf-fee-amt { font-family: "Fraunces", Georgia, serif; font-weight: 300; font-size: 22pt; color: #7a2535; margin: 0 0 2mm; letter-spacing: -0.02em; }',
      '.pdf-fee-note { font-family: "Fraunces", Georgia, serif; font-style: italic; font-size: 10pt; color: #5a5550; margin: 0; max-width: 130mm; margin-left: auto; margin-right: auto; line-height: 1.5; }',
      // Process steps
      '.pdf-process { margin-bottom: 10mm; page-break-inside: avoid; }',
      '.pdf-process-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 5mm; }',
      '.pdf-process-step { background: #faf9f7; border: 1px solid #e4ddd5; border-radius: 3px; padding: 5mm 4mm; }',
      '.pdf-process-num { font-family: "Fraunces", Georgia, serif; font-weight: 200; font-size: 16pt; color: #7a2535; line-height: 1; margin: 0 0 2mm; }',
      '.pdf-process-name { font-family: "Fraunces", Georgia, serif; font-style: italic; font-size: 10pt; color: #2a2520; margin: 0 0 2mm; }',
      '.pdf-process-desc { font-size: 8.5pt; color: #5a5550; line-height: 1.5; margin: 0; }',
      // Footer
      '.pdf-foot { border-top: 1px solid #e4ddd5; padding-top: 6mm; text-align: center; font-size: 8pt; color: #7a7570; line-height: 1.6; }',
      '.pdf-foot p { margin: 0 0 1mm; }',
      '.pdf-foot a { color: #7a2535; text-decoration: none; }',
      '.pdf-disclaimer { font-family: "Fraunces", Georgia, serif; font-style: italic; font-size: 9pt; color: #5a5550; text-align: center; margin: 0 0 6mm; max-width: 150mm; margin-left: auto; margin-right: auto; line-height: 1.55; }',
      // Print: drop the toolbar + paper chrome so only the A4 doc prints
      '@media print {',
      '  body { background: #ffffff !important; }',
      '  .pdf-toolbar { display: none !important; }',
      '  .pdf-sheet-wrap { padding: 0 !important; }',
      '  .pdf-sheet { width: auto !important; min-height: 0 !important; padding: 0 !important; box-shadow: none !important; }',
      '}'
    ].join('\n');

    var toolbar = '<div class="pdf-toolbar">' +
        '<div class="pdf-toolbar-left">' +
          '<p class="pdf-toolbar-title">Felicitations · Wedding Stationery Quote</p>' +
          '<p class="pdf-toolbar-meta">Quote #' + escHtml(quoteId) + ' · ' + escHtml(today) + '</p>' +
        '</div>' +
        '<div class="pdf-toolbar-actions">' +
          '<button type="button" class="pdf-toolbar-btn pdf-toolbar-btn-ghost" onclick="window.close()">Close</button>' +
          '<button type="button" class="pdf-toolbar-btn pdf-toolbar-btn-primary" onclick="window.print()">↓ Save as PDF</button>' +
        '</div>' +
      '</div>';

    return '<!DOCTYPE html><html lang="en"><head>' +
      '<meta charset="utf-8">' +
      '<title>Felicitations Quote · ' + escHtml(couple || quoteId) + '</title>' +
      '<link rel="preconnect" href="https://fonts.googleapis.com">' +
      '<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>' +
      '<link href="https://fonts.googleapis.com/css2?family=Fraunces:ital,wght@0,200;0,300;0,400;1,200;1,300;1,400&family=DM+Sans:wght@400;500&display=swap" rel="stylesheet">' +
      '<style>' + css + '</style>' +
      '</head><body>' +
      toolbar +
      '<div class="pdf-sheet-wrap"><div class="pdf-sheet">' +
      '<div class="pdf-doc">' +
        '<header class="pdf-head">' +
          '<p class="pdf-brand">Felicitations · Couture Stationery · Perth</p>' +
          '<h1 class="pdf-title">Your <em>wedding stationery</em> quote</h1>' +
          '<p class="pdf-meta">' + metaLine + '</p>' +
          '<p class="pdf-quote-id">Quote #' + escHtml(quoteId) + '</p>' +
        '</header>' +
        '<p class="pdf-package"><strong>' + escHtml(scopeLbl) + '</strong> · ' + escHtml(tierLbl) +
        '<span class="pdf-package-desc" style="display:block">' + escHtml(((SCOPE_DESCS[state.selectedCategory] || '') + ' ' + (TIER_DESCS[state.des && state.des.type] || '')).trim()) + '</span></p>' +
        '<p class="pdf-section-head">Itemised investment</p>' +
        '<div class="pdf-phases">' + phasesHtml + '</div>' +
        '<div class="pdf-total-bar">' +
          '<span class="pdf-total-label">Total estimated investment</span>' +
          '<span class="pdf-total-amt">' + fmt0(totalAmt) + '</span>' +
        '</div>' +
        '<div class="pdf-fee">' +
          '<p class="pdf-fee-eyebrow">Begin your design</p>' +
          '<p class="pdf-fee-amt">' + fmt0(feeAmt) + ' Design Fee</p>' +
          '<p class="pdf-fee-note">Your Design Fee begins your design and reserves your spot in our studio. Printing is invoiced separately, once you approve your design.</p>' +
        '</div>' +
        '<p class="pdf-section-head">What happens next</p>' +
        '<div class="pdf-process">' +
          '<div class="pdf-process-grid">' +
            '<div class="pdf-process-step"><p class="pdf-process-num">01</p><p class="pdf-process-name">Secure your spot</p><p class="pdf-process-desc">Your Design Fee reserves your place in production and begins your design. We send a short questionnaire for your wording, details and preferences.</p></div>' +
            '<div class="pdf-process-step"><p class="pdf-process-num">02</p><p class="pdf-process-name">Design &amp; refine</p><p class="pdf-process-desc">Your first proof arrives in ' + proofDaysLabel() + '. We refine it with you over digital proofs, fine-tuning every detail.</p></div>' +
            '<div class="pdf-process-step"><p class="pdf-process-num">03</p><p class="pdf-process-name">Approve, confirm &amp; deliver</p><p class="pdf-process-desc">Nothing prints without your written approval. We print, hand-finish in Perth, and ship Australia-wide, tracked.</p></div>' +
          '</div>' +
        '</div>' +
        '<p class="pdf-disclaimer">Estimate only. Final details, quantities and finishes are confirmed after your Design Fee. All prices in AUD, GST included.</p>' +
        '<footer class="pdf-foot">' +
          '<p><a href="https://felicitations.com.au">felicitations.com.au</a> · <a href="mailto:design@felicitations.com.au">design@felicitations.com.au</a> · Perth, WA</p>' +
          '<p>Generated ' + escHtml(today) + '</p>' +
        '</footer>' +
      '</div>' +   /* /pdf-doc */
      '</div></div>' +  /* /pdf-sheet /pdf-sheet-wrap */
      '</body></html>';
  }

  function refreshStickyCta() {
    var btn = document.querySelector('.sticky-bar .btn-primary');
    if (!btn) return;
    var cur = parseInt(state.currentTab, 10) || 1;
    btn.textContent = cur < 3 ? 'Continue →' : 'Secure your spot →';
  }

  // ── Section toggle (entire STD / INV / OTD on/off) ──────────
  function toggleBlock(id) {
    if (!state[id]) return;
    state[id].on = !state[id].on;
    var blockId = 'cust' + id.charAt(0).toUpperCase() + id.slice(1);
    var block = document.getElementById(blockId);
    if (block) {
      block.classList.toggle('off', !state[id].on);
      // Auto-expand when turned ON, auto-collapse when turned OFF
      block.classList.toggle('collapsed', !state[id].on);
    }
    recompute();
  }

  // Manually expand/collapse a section (Edit button)
  function toggleExpanded(id) {
    var blockId = 'cust' + id.charAt(0).toUpperCase() + id.slice(1);
    var block = document.getElementById(blockId);
    if (!block) return;
    block.classList.toggle('collapsed');
    recompute();
  }

  // ── Tab navigation ───────────────────────────────────────────
  function goTab(n) {
    n = parseInt(n, 10) || 1;
    if (n < 1 || n > 3) return;
    document.querySelectorAll('.fel-v2-full .tab-btn').forEach(function(el) {
      var tn = parseInt(el.getAttribute('data-tab'), 10);
      el.classList.toggle('active', tn === n);
      el.classList.toggle('completed', tn < n);
    });
    document.querySelectorAll('.fel-v2-full .tab-pane').forEach(function(el) {
      el.classList.toggle('active', el.id === 'tabPane' + n);
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
    state.currentTab = n;
    refreshStickyCta();
  }

  window.FEL_V2_FULL.onField = onField;
  window.FEL_V2_FULL.selectScope = selectScope;
  window.FEL_V2_FULL.selectTier = selectTier;
  window.FEL_V2_FULL.toggleDesCheck = toggleDesCheck;
  window.FEL_V2_FULL.onStdQty = onStdQty;
  window.FEL_V2_FULL.setStdPrintStyle = setStdPrintStyle;
  window.FEL_V2_FULL.setStdPrint = setStdPrint;
  window.FEL_V2_FULL.setStdAcSize = setStdAcSize;
  window.FEL_V2_FULL.toggleStdCheck = toggleStdCheck;
  window.FEL_V2_FULL.toggleStdRibbon = toggleStdRibbon;
  window.FEL_V2_FULL.setStdRibbon = setStdRibbon;
  window.FEL_V2_FULL.toggleStdWax = toggleStdWax;
  window.FEL_V2_FULL.setStdWaxType = setStdWaxType;
  window.FEL_V2_FULL.onInvQty = onInvQty;
  window.FEL_V2_FULL.setInvSize = setInvSize;
  window.FEL_V2_FULL.setInvFormat = setInvFormat;
  window.FEL_V2_FULL.setInvPrintStyle = setInvPrintStyle;
  window.FEL_V2_FULL.setInvPrint = setInvPrint;
  window.FEL_V2_FULL.setInvInfo = setInvInfo;
  window.FEL_V2_FULL.setInvShape = setInvShape;
  window.FEL_V2_FULL.toggleInvCheck = toggleInvCheck;
  window.FEL_V2_FULL.toggleInvRibbon = toggleInvRibbon;
  window.FEL_V2_FULL.setInvRibbon = setInvRibbon;
  window.FEL_V2_FULL.toggleInvWax = toggleInvWax;
  window.FEL_V2_FULL.setInvWaxType = setInvWaxType;
  window.FEL_V2_FULL.toggleOtdItem = toggleOtdItem;
  window.FEL_V2_FULL.setOtdField = setOtdField;
  window.FEL_V2_FULL.toggleOtdUpgrade = toggleOtdUpgrade;
  window.FEL_V2_FULL.setOtdRibbon = setOtdRibbon;
  window.FEL_V2_FULL.toggleInvPockets = toggleInvPockets;
  window.FEL_V2_FULL.setInvPocketFoil = setInvPocketFoil;
  window.FEL_V2_FULL.goTab = goTab;
  window.FEL_V2_FULL.toggleEstDetail = toggleEstDetail;
  window.FEL_V2_FULL.changePackage = changePackage;
  window.FEL_V2_FULL.changeTier = changeTier;
  window.FEL_V2_FULL.toggleBlock = toggleBlock;
  window.FEL_V2_FULL.toggleExpanded = toggleExpanded;
  window.FEL_V2_FULL.onSecureCta = onSecureCta;
  window.FEL_V2_FULL.editPhase = editPhase;
  window.FEL_V2_FULL.toggleSampleKit = toggleSampleKit;
  window.FEL_V2_FULL.onStickyContinue = onStickyContinue;
  window.FEL_V2_FULL.shareWithPartner = shareWithPartner;
  window.FEL_V2_FULL.downloadEstimate = downloadEstimate;
  window.FEL_V2_FULL.openBookCall = openBookCall;

  document.addEventListener('DOMContentLoaded', function() {
    // Full UI only renders when ?mode=full is in URL - otherwise Quick owns the page.
    var mode = new URLSearchParams(window.location.search).get('mode');
    if (mode !== 'full') return; // stay hidden (default display:none in CSS)

    // Disable browser scroll restoration - on refresh the page height changes
    // when we hide the Quick path + reveal the Full path, so the saved scroll
    // position lands in the wrong spot (usually deep in the footer).
    try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}

    var fullRoot = document.querySelector('.fel-v2-full');
    if (fullRoot) fullRoot.style.display = 'block';

    readUrlParams();
    hydrateUI();
    if (state._startTab && state._startTab > 1) goTab(state._startTab);

    // After hydration + layout settle, scroll the calculator into view at the top.
    // requestAnimationFrame ensures we wait for the browser to apply display:block
    // and lay out the full-path content before measuring.
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        if (fullRoot && typeof fullRoot.scrollIntoView === 'function') {
          fullRoot.scrollIntoView({ behavior: 'auto', block: 'start' });
        }
      });
    });

    // ═══ BACKEND SYNC ═══
    // Pre-fill from logged-in Shopify customer (set by quote-calculator-init.liquid)
    var FEL = window.FELICITATIONS || {};
    if (FEL.customerId && !state.shopifyCustomerId) {
      state.shopifyCustomerId = String(FEL.customerId);
    }
    if (FEL.customerEmail && !state.email) {
      state.email = FEL.customerEmail;
      var emailEl = document.getElementById('ffEmail');
      if (emailEl) emailEl.value = FEL.customerEmail;
    }
    initBackendSync();
  });

  // ═══════════════════════════════════════════════════════════
  // BACKEND SYNC - customer creation + state sync + PDF upload
  // Talks to the same Netlify functions v1 uses (/apps/quote/*):
  //   /customer  → create or find Shopify customer by email
  //   /update    → write all quote_* metafields + maintain tags
  //   /pdf       → upload base64 PDF to Shopify Files, write quote_pdf_url
  // ═══════════════════════════════════════════════════════════
  var BACKEND_FEL  = (window && window.FELICITATIONS) || {};
  var BACKEND_HAS  = !!(BACKEND_FEL && BACKEND_FEL.proxyBase);
  var _syncTimer   = null;
  var _syncInFlight = new Set ? new Set() : null;
  var _lastSyncBody = '';

  function apiCall(endpoint, body) {
    if (!BACKEND_HAS) return Promise.resolve(null);
    return fetch(BACKEND_FEL.proxyBase + '/' + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(res) {
      if (!res.ok) throw new Error(endpoint + ' returned ' + res.status);
      return res.json();
    }).then(function(payload) {
      // Backend signals stale customerId (customer deleted) - clear so next
      // /customer call re-creates or re-finds.
      if (payload && payload.clearCustomerId && state.shopifyCustomerId) {
        console.warn('[FEL_V2_FULL] backend signalled stale customerId - clearing');
        state.shopifyCustomerId = null;
      }
      return payload;
    }).catch(function(err) {
      console.warn('[FEL_V2_FULL] ' + endpoint + ' failed:', err && err.message);
      return null;
    });
  }

  // v1-compatible state snapshot - same shape as v1 buildStateSnapshot
  // so the existing update.js summary helper works without modification.
  function buildBackendSnapshot() {
    var b = (window.FEL_PRICING && window.FEL_PRICING.calcAll)
      ? window.FEL_PRICING.calcAll(state)
      : { std: 0, inv: 0, otd: 0, des: 0, total: 0 };
    if (!state.quoteId) state.quoteId = 'FEL-' + Math.random().toString(36).slice(2, 10).toUpperCase();
    var snap = {};
    // Copy state shallow + nested categories
    Object.keys(state).forEach(function(k) { snap[k] = state[k]; });
    snap.version = 2;
    snap.totals = {
      designDeposit: b.des,
      fullEstimate: b.total,
      breakdown: { std: b.std, inv: b.inv, otd: b.otd, design: b.des }
    };
    snap.itemCount = (state.std && state.std.on ? 1 : 0)
                   + (state.inv && state.inv.on ? 1 : 0)
                   + (state.otd && state.otd.on ? Object.keys(state.otd.items || {}).filter(function(id){ return state.otd.items[id].on; }).length : 0);
    snap.lastUpdatedAt = new Date().toISOString();
    snap.source = 'calc-v2-full';
    return snap;
  }

  // POST /apps/quote/update - dedup by reason+step, swallow noise
  function syncToBackend(reason) {
    if (!state.shopifyCustomerId || !BACKEND_HAS) return;
    var step = parseInt(state.currentTab, 10) || 1;
    var key = reason + '-' + step;
    if (_syncInFlight && _syncInFlight.has(key)) return;
    if (_syncInFlight) _syncInFlight.add(key);
    var body = JSON.stringify({
      customerId: state.shopifyCustomerId,
      state: buildBackendSnapshot(),
      stepReached: step,
      syncReason: reason
    });
    // Skip if identical body just sent (avoids noise on rapid recompute)
    if (body === _lastSyncBody) {
      if (_syncInFlight) _syncInFlight.delete(key);
      return;
    }
    _lastSyncBody = body;
    fetch(BACKEND_FEL.proxyBase + '/update', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body,
      keepalive: true
    }).catch(function(){}).then(function(){
      setTimeout(function(){ if (_syncInFlight) _syncInFlight.delete(key); }, 1500);
    });
  }

  // Debounced version - fires after 1.5s of inactivity. Used on field changes
  // so we don't hammer the backend on every keystroke / dropdown change.
  function debouncedSync(reason) {
    if (_syncTimer) clearTimeout(_syncTimer);
    _syncTimer = setTimeout(function() { syncToBackend(reason || 'state_change'); }, 1500);
  }

  // Create or look up Shopify customer by email; saves customerId to state.
  function createCustomerIfNeeded() {
    if (!BACKEND_HAS || state.shopifyCustomerId || !isValidEmail(state.email)) return Promise.resolve(null);
    return apiCall('customer', {
      email: state.email,
      coupleNames: state.coupleNames || '',
      weddingDate: state.weddingDate || '',
      guestCount: state.guestCount || ''
    }).then(function(result) {
      if (result && result.customerId) {
        state.shopifyCustomerId = result.customerId;
        // Initial sync now that we have a customer ID
        syncToBackend('first_contact');
      }
      return result;
    });
  }

  // ── PDF generation + upload to Shopify Files ──────────────
  // Renders buildPdfHtml() offscreen, rasterises via html2pdf.js (lazy-loaded
  // from CDN), POSTs base64 to /apps/quote/pdf which uploads to Shopify Files
  // and writes the URL to customer metafield felicitations.quote_pdf_url.
  var HTML2PDF_CDN = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js';
  var _html2pdfPromise = null;
  var _pdfUploadInFlight = false;
  var _tab3PdfTimer = null;

  function ensureHtml2Pdf() {
    if (window.html2pdf) return Promise.resolve(window.html2pdf);
    if (_html2pdfPromise) return _html2pdfPromise;
    _html2pdfPromise = new Promise(function(resolve, reject) {
      var s = document.createElement('script');
      s.src = HTML2PDF_CDN;
      s.async = true;
      s.onload = function() { resolve(window.html2pdf); };
      s.onerror = function() { _html2pdfPromise = null; reject(new Error('html2pdf load failed')); };
      document.head.appendChild(s);
    });
    return _html2pdfPromise;
  }

  function generatePdfBlob() {
    return ensureHtml2Pdf().then(function() {
      var breakdown = (window.FEL_PRICING && window.FEL_PRICING.calcAll)
        ? window.FEL_PRICING.calcAll(state)
        : { std: 0, inv: 0, otd: 0, des: 0, total: 0 };
      if (!state.quoteId) state.quoteId = 'FEL-' + Math.random().toString(36).slice(2, 10).toUpperCase();
      var html = buildPdfHtml(breakdown);

      var holder = document.createElement('div');
      holder.style.cssText = 'position:fixed;left:-10000px;top:0;width:210mm;background:#fff;';
      holder.innerHTML = html;
      document.body.appendChild(holder);
      var target = holder.querySelector('.pdf-sheet') || holder;

      var fontsReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
      return fontsReady
        .then(function() { return new Promise(function(r){ setTimeout(r, 250); }); })
        .then(function() {
          var opt = {
            margin: 0,
            filename: 'Felicitations-Quote-' + state.quoteId + '.pdf',
            image: { type: 'jpeg', quality: 0.95 },
            html2canvas: { scale: 2, useCORS: true, letterRendering: true, backgroundColor: '#ffffff' },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            pagebreak: { mode: ['avoid-all', 'css'] }
          };
          return window.html2pdf().set(opt).from(target).outputPdf('blob');
        })
        .then(function(blob) {
          try { document.body.removeChild(holder); } catch(e) {}
          return blob;
        })
        .catch(function(err) {
          try { document.body.removeChild(holder); } catch(e) {}
          throw err;
        });
    });
  }

  function blobToBase64(blob) {
    return new Promise(function(resolve, reject) {
      var r = new FileReader();
      r.onload = function() {
        var s = String(r.result || '');
        var i = s.indexOf(',');
        resolve(i >= 0 ? s.slice(i + 1) : s);
      };
      r.onerror = reject;
      r.readAsDataURL(blob);
    });
  }

  function scheduleTab3PdfUpload() {
    if (_tab3PdfTimer) clearTimeout(_tab3PdfTimer);
    _tab3PdfTimer = setTimeout(function() {
      _tab3PdfTimer = null;
      if (state.shopifyCustomerId && parseInt(state.currentTab, 10) === 3) {
        uploadPdfToShopify('tab3_entered');
      }
    }, 2500);
  }

  function cancelTab3PdfUpload() {
    if (_tab3PdfTimer) { clearTimeout(_tab3PdfTimer); _tab3PdfTimer = null; }
  }

  function uploadPdfToShopify(reason) {
    if (!BACKEND_HAS || !state.shopifyCustomerId) return Promise.resolve(null);
    if (_pdfUploadInFlight) return Promise.resolve(null);
    _pdfUploadInFlight = true;
    return generatePdfBlob()
      .then(function(blob) { return blobToBase64(blob); })
      .then(function(b64) {
        var filename = 'Felicitations-Quote-' + (state.quoteId || Date.now()) + '.pdf';
        var altParts = ['Wedding stationery quote'];
        if (state.coupleNames) altParts.push(state.coupleNames);
        if (state.quoteId) altParts.push(state.quoteId);
        return apiCall('pdf', {
          customerId: state.shopifyCustomerId,
          pdfBase64: b64,
          filename: filename,
          alt: altParts.join(' · ')
        });
      })
      .then(function(res) {
        _pdfUploadInFlight = false;
        if (res && res.url) {
          state.lastPdfUrl = res.url;
          syncToBackend(reason || 'pdf_uploaded');
        }
        return res;
      })
      .catch(function(err) {
        _pdfUploadInFlight = false;
        console.warn('[FEL_V2_FULL] PDF upload failed:', err && err.message);
        return null;
      });
  }

  function initBackendSync() {
    if (!BACKEND_HAS) {
      console.info('[FEL_V2_FULL] Shopify App Proxy not configured - backend sync disabled');
      return;
    }

    // ── Hook email field: on blur with a valid email, create the customer
    var emailEl = document.getElementById('ffEmail');
    if (emailEl) {
      emailEl.addEventListener('blur', function() {
        if (isValidEmail(emailEl.value.trim())) {
          state.email = emailEl.value.trim();
          createCustomerIfNeeded();
        }
      });
    }

    // ── Wrap recompute to trigger debounced sync after any state change
    var _origRecompute = recompute;
    recompute = function() {
      var r = _origRecompute.apply(this, arguments);
      if (state.shopifyCustomerId) debouncedSync('state_change');
      return r;
    };

    // ── Wrap tab navigation to sync immediately at each tab transition
    //    + auto-upload PDF after 2.5s on Tab 3 (debounced; cancels if user leaves)
    var _origGoTab = goTab;
    goTab = function(n) {
      var r = _origGoTab.apply(this, arguments);
      var tabNum = parseInt(n, 10) || 1;
      if (state.shopifyCustomerId) syncToBackend('tab_milestone');
      if (tabNum === 3 && state.shopifyCustomerId) {
        scheduleTab3PdfUpload();
      } else {
        cancelTab3PdfUpload();
      }
      return r;
    };
    // Re-export the wrapped versions so HTML onclick handlers hit the new ones
    window.FEL_V2_FULL.goTab = goTab;

    // ── Hook Secure CTA: sync + upload PDF before cart-add (best-effort)
    var _origSecure = onSecureCta;
    onSecureCta = function() {
      if (state.shopifyCustomerId) {
        // Fire and forget - don't block cart-add on either call
        syncToBackend('secured');
        uploadPdfToShopify('secured');
      }
      return _origSecure.apply(this, arguments);
    };
    window.FEL_V2_FULL.onSecureCta = onSecureCta;

    // ── Hook Download Estimate: also upload to Shopify Files
    var _origDownload = downloadEstimate;
    downloadEstimate = function() {
      var r = _origDownload.apply(this, arguments);
      if (state.shopifyCustomerId) uploadPdfToShopify('downloaded');
      return r;
    };
    window.FEL_V2_FULL.downloadEstimate = downloadEstimate;

    // ── sendBeacon on unload so the last state always lands in the backend
    window.addEventListener('beforeunload', function() {
      if (!state.shopifyCustomerId) return;
      try {
        var payload = JSON.stringify({
          customerId: state.shopifyCustomerId,
          state: buildBackendSnapshot(),
          stepReached: parseInt(state.currentTab, 10) || 1,
          syncReason: 'session_end'
        });
        navigator.sendBeacon(BACKEND_FEL.proxyBase + '/update', new Blob([payload], { type: 'application/json' }));
      } catch (e) {}
    });

    // ── If already logged in (customerId pre-filled), fire initial sync now
    if (state.shopifyCustomerId) {
      setTimeout(function() { syncToBackend('hydrate'); }, 800);
    }

    console.info('[FEL_V2_FULL] Backend sync armed. customer:', state.shopifyCustomerId || 'pending');
  }
})();
